var $790lB$digitalbranchapp = require("@digitalbranch/app");


function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $131d50229c8def6f$exports = {};
var $eb7c8ab7a231f03b$exports = {};

$parcel$export($eb7c8ab7a231f03b$exports, "SCAFFOLD_SERVICE_TOKEN", () => $eb7c8ab7a231f03b$export$cfeb4fcbf56fdcb);
$parcel$export($eb7c8ab7a231f03b$exports, "VIEWPORT_SERVICE_TOKEN", () => $eb7c8ab7a231f03b$export$b8e6ddf306f09d18);
$parcel$export($eb7c8ab7a231f03b$exports, "ScaffoldService", () => $eb7c8ab7a231f03b$export$ce91d08d0899845f);
$parcel$export($eb7c8ab7a231f03b$exports, "ViewportService", () => $eb7c8ab7a231f03b$export$788874a683e9c66);
$parcel$export($eb7c8ab7a231f03b$exports, "uiScaffold", () => $eb7c8ab7a231f03b$export$b8d36ba975b9169b);

var $57d7cd5161bd7484$export$2e2bcd8739ae039 = /* html */ `
<div class="ui-scaffold" *bind:class="{ 'ui-scaffold--has-top-app-bar-small': hasTopAppBar }">
  <div class="ui-scaffold__top-app-bar">
    <slot name="top-app-bar" @slotchange="onSlotChange"></slot>
  </div>

  <div class="ui-scaffold__navigation-drawer">
    <slot name="navigation-drawer"></slot>
  </div>

  <div class="ui-scaffold__navigation-rail">
    <slot name="navigation-rail"></slot>
  </div>

  <div class="ui-scaffold__content">
    <slot></slot>
  </div>
</div>
`;


var $bc0722caaf6af1bb$export$2e2bcd8739ae039 = /* css */ `
.ui-scaffold {
  --ui-scaffold-app-background: hsl(var(--ui-sys-color-surface));
  --ui-scaffold-padding-top: 0;

  width: 100%;
  height: 100%;
  display: flex;
  background-color: hsl(var(--ui-scaffold-app-background));
  overflow: hidden;

  .ui-scaffold__content {
    flex: 1;
    overflow: hidden;
  }

  .ui-scaffold__fab {
    position: fixed;
    bottom: calc(var(--ui-sys-unit) * 16);
    right: calc(var(--ui-sys-unit) * 16);
    z-index: 3;
  }

  &.ui-scaffold--has-top-app-bar-small {
    --ui-scaffold-padding-top: var(--ui-top-app-bar-small-height);
  }

  &.ui-scaffold--has-top-app-bar-medium {
    --ui-scaffold-padding-top: var(--ui-top-app-bar-medium-height);
  }

  &.ui-scaffold--has-top-app-bar-medium,
  &.ui-scaffold--has-top-app-bar-small {
    .ui-scaffold__navigation-rail {
      padding-top: var(--ui-scaffold-padding-top);
    }
    .ui-scaffold__navigation-drawer {
      padding-top: var(--ui-scaffold-padding-top);
    }
    .ui-scaffold__content {
      padding-top: var(--ui-scaffold-padding-top);
    }
  }
}

@media screen and (max-width: 600px) {
  .ui-scaffold {
    .ui-scaffold__fab {
      bottom: calc(
        var(--ui-sys-unit) * 16 + var(--safe-area-inset-bottom) +
          var(--ui-navigation-bar-container-height)
      );
    }
  }
}`;


const $eb7c8ab7a231f03b$var$ViewPortSizes = [
    {
        name: 'mobile',
        min: 0,
        max: 600,
        orientation: 'landscape-primary',
        displayMode: 'browser',
        safeArea: {
            top: 0,
            left: 0,
            bottom: 0,
            right: 0
        }
    },
    {
        name: 'tablet',
        min: 601,
        max: 1072,
        orientation: 'landscape-primary',
        displayMode: 'browser',
        safeArea: {
            top: 0,
            left: 0,
            bottom: 0,
            right: 0
        }
    },
    {
        name: 'desktop',
        min: 1073,
        max: Infinity,
        orientation: 'landscape-primary',
        displayMode: 'browser',
        safeArea: {
            top: 0,
            left: 0,
            bottom: 0,
            right: 0
        }
    }
];
const $eb7c8ab7a231f03b$var$getComputedValue = (computedStyles, property)=>parseInt(computedStyles.getPropertyValue(property).replace('px', ''), 10) || 0;
const $eb7c8ab7a231f03b$var$getViewPort = (width)=>{
    const viewport = $eb7c8ab7a231f03b$var$ViewPortSizes.find(({ min: min, max: max })=>width >= min && width <= max) || null;
    if (viewport) {
        viewport.displayMode = $eb7c8ab7a231f03b$var$getDisplayMode();
        viewport.safeArea = $eb7c8ab7a231f03b$var$getSafeArea(viewport.displayMode);
        if (screen.orientation) viewport.orientation = screen.orientation.type;
    }
    return viewport;
};
const $eb7c8ab7a231f03b$var$getDisplayMode = ()=>window.matchMedia('(display-mode: standalone)').matches ? 'standalone' : 'browser';
const $eb7c8ab7a231f03b$var$getSafeArea = (displayMode)=>{
    if (displayMode === 'standalone') {
        const computedStyles = getComputedStyle(document.documentElement);
        return {
            top: $eb7c8ab7a231f03b$var$getComputedValue(computedStyles, '--safe-area-inset-top'),
            left: $eb7c8ab7a231f03b$var$getComputedValue(computedStyles, '--safe-area-inset-left'),
            bottom: $eb7c8ab7a231f03b$var$getComputedValue(computedStyles, '--safe-area-inset-bottom'),
            right: $eb7c8ab7a231f03b$var$getComputedValue(computedStyles, '--safe-area-inset-right')
        };
    }
    return {
        top: 0,
        left: 0,
        bottom: 0,
        right: 0
    };
};
const $eb7c8ab7a231f03b$var$LOCAL_STORAGE_THEME_KEY = 'ui-material-design-theme-settings';
const $eb7c8ab7a231f03b$export$cfeb4fcbf56fdcb = 'scaffoldService';
const $eb7c8ab7a231f03b$export$b8e6ddf306f09d18 = 'viewportService';
class $eb7c8ab7a231f03b$export$ce91d08d0899845f {
    #themeSettings;
    #handlers;
    constructor(){
        this.#themeSettings = {
            colorScheme: 'dark'
        };
        this.#handlers = {
            colorScheme: []
        };
    }
    get colorScheme() {
        return this.#themeSettings.colorScheme;
    }
    set colorScheme(colorScheme) {
        this.#setThemeSettings({
            colorScheme: colorScheme
        });
        this.#handlers.colorScheme.forEach((handler)=>handler(colorScheme));
    }
    get themeSettings() {
        return {
            ...this.#themeSettings
        };
    }
    set themeSettings(themeSettings) {
        this.#setThemeSettings(themeSettings);
    }
    on(event, handler) {
        this.#handlers[event].push(handler);
    }
    off(event, handler) {
        const handlers = this.#handlers[event];
        this.#handlers[event] = handlers.filter((currentHandler)=>currentHandler !== handler);
    }
    #setThemeSettings(themeSettings) {
        const newThemeSettings = {
            ...this.#themeSettings,
            ...themeSettings
        };
        localStorage.setItem($eb7c8ab7a231f03b$var$LOCAL_STORAGE_THEME_KEY, JSON.stringify(newThemeSettings));
        this.#themeSettings = newThemeSettings;
    }
}
class $eb7c8ab7a231f03b$export$788874a683e9c66 {
    #viewport;
    #handlers;
    constructor(){
        this.#handleResize = ()=>{
            this.viewport = $eb7c8ab7a231f03b$var$getViewPort(window.innerWidth);
        };
        this.#viewport = $eb7c8ab7a231f03b$var$getViewPort(window.innerWidth);
        this.#handlers = {
            viewport: []
        };
        window.addEventListener('resize', this.#handleResize);
        if (screen.orientation) screen.orientation.addEventListener('change', this.#handleResize);
    }
    set viewport(viewport) {
        const currentViewport = this.#viewport;
        if (currentViewport?.name === viewport?.name) return;
        this.#viewport = viewport;
        if (this.#viewport) this.#notify('viewport', this.#viewport);
    }
    get viewport() {
        return this.#viewport;
    }
    on(event, cb) {
        this.#handlers[event].push(cb);
    }
    off(event, cb) {
        const handlers = this.#handlers[event];
        this.#handlers[event] = handlers.filter((handler)=>handler !== cb);
    }
    destroy() {
        window.removeEventListener('resize', this.#handleResize);
    }
    #notify(event, payload) {
        this.#handlers[event].forEach((cb)=>cb(payload));
    }
    #handleResize;
}
const $eb7c8ab7a231f03b$export$b8d36ba975b9169b = (0, $790lB$digitalbranchapp.defineComponent)({
    name: 'ui-scaffold',
    inject: [
        $eb7c8ab7a231f03b$export$cfeb4fcbf56fdcb
    ],
    template: $57d7cd5161bd7484$export$2e2bcd8739ae039,
    css: $bc0722caaf6af1bb$export$2e2bcd8739ae039,
    data () {
        return {
            hasTopAppBar: false,
            darkModePreference: null
        };
    },
    listeners: {
        ready () {
            const darkModePreference = window.matchMedia('(prefers-color-scheme: dark)');
            const colorScheme = darkModePreference.matches ? 'dark' : 'light';
            this.boundHandleColorSchemeChange = this.handleColorSchemeChange.bind(this);
            this.darkModePreference = darkModePreference;
            this.scaffoldService.on('colorScheme', this.boundHandleColorSchemeChange);
            this.boundOnCustomPropertyHeight = this.onCustomPropertyHeight.bind(this);
            this.boundHandleDarkModePreferenceChange = this.handleDarkModePreferenceChange.bind(this);
            this.$node.addEventListener('custom-property-height', this.boundOnCustomPropertyHeight);
            const themeSettings = {
                colorScheme: colorScheme,
                ...this.getThemeSettings()
            };
            this.scaffoldService.themeSettings = themeSettings;
            this.scaffoldService.colorScheme = themeSettings.colorScheme;
        },
        disconnected () {
            this.darkModePreference?.removeEventListener('change', this.boundHandleDarkModePreferenceChange);
            this.scaffoldService.off('colorScheme', this.boundHandleColorSchemeChange);
            this.$node.removeEventListener('custom-property-height', this.boundOnCustomPropertyHeight);
        }
    },
    methods: {
        onSlotChange (e) {
            if (!e.target) return;
            const target = e.target;
            const { name: name } = target;
            const hasNodes = target.assignedNodes().length > 0;
            if (name === 'top-app-bar') this.hasTopAppBar = hasNodes;
        },
        onCustomPropertyHeight (e) {
            const { detail: detail } = e;
            this.$node.shadowRoot?.adoptedStyleSheets[0].insertRule(`:host { --ui-top-app-bar-small-height: ${detail}; }`);
        },
        getThemeSettings () {
            try {
                const storedSettings = localStorage.getItem($eb7c8ab7a231f03b$var$LOCAL_STORAGE_THEME_KEY) || '{ "colorScheme": "dark" }';
                return JSON.parse(storedSettings);
            } catch  {
                return {
                    colorScheme: 'dark'
                };
            }
        },
        handleDarkModePreferenceChange () {
            const colorScheme = this.scaffoldService.colorScheme;
            this.scaffoldService.colorScheme = colorScheme === 'dark' ? 'light' : 'dark';
        },
        handleColorSchemeChange (colorScheme) {
            document.documentElement.setAttribute('data-mode', colorScheme);
        }
    }
});


var $9703e2f3f4452c31$exports = {};
var $338b2516d28ab608$exports = {};

$parcel$export($338b2516d28ab608$exports, "uiTopAppBarMedium", () => $338b2516d28ab608$export$2059614bf6591282);

var $b48b9edc354fc8ad$export$2e2bcd8739ae039 = /* html */ `
<div class="ui-top-app-bar-medium">
  <div className="ui-top-app-bar-medium__container">
    <div className="ui-top-app-bar-medium__leading-icon">
      <slot name="leading-icon"/>
    </div>
    <div className="ui-top-app-bar-medium__trailing-icons">
      <slot name="trailing-icons"/>
    </div>
    <div className="ui-top-app-bar-medium__headline">
      <slot name="headline"/>
    </div>
  </div>
  <slot name="divider"/>
</div>
`;


var $12ba0112ebd8b13f$export$2e2bcd8739ae039 = /* css */ `
:host {
  --ui-top-app-bar-medium-height: calc(var(--ui-sys-unit) * 112);
  --ui-top-app-bar-medium-color: var(--ui-sys-color-surface);
  --ui-top-app-bar-medium-container-padding-left: calc(var(--ui-sys-unit) * 16);
  --ui-top-app-bar-medium-container-padding-right: calc(var(--ui-sys-unit) * 16);

  --ui-top-app-bar-medium-headline-font: var(--ui-sys-typescale-headline-small-font-family-name);
  --ui-top-app-bar-medium-headline-size: var(--ui-sys-typescale-headline-small-font-size);
  --ui-top-app-bar-medium-headline-weight: var(--ui-sys-typescale-headline-small-font-weight);
  --ui-top-app-bar-medium-headline-line-height: var(--ui-sys-typescale-headline-small-line-height);
  --ui-top-app-bar-medium-headline-color: var(--ui-sys-color-on-surface);

  --ui-top-app-bar-medium-leading-icon-color: var(--ui-sys-color-on-surface);
  --ui-top-app-bar-medium-trailing-icon-color: var(--ui-sys-color-on-surface);
}

.ui-top-app-bar-medium {
  height: var(--ui-top-app-bar-medium-height);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 2;

  .ui-top-app-bar-medium__container {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 100%;
    height: 100%;
    flex-shrink: 0;
    background-color: hsl(var(--ui-top-app-bar-medium-color));
    padding-left: var(--ui-top-app-bar-medium-container-padding-left);
    padding-right: var(--ui-top-app-bar-medium-container-padding-right);
    z-index: 4;
  }

  .ui-top-app-bar-medium__leading-icon {
    .ui-button {
      --ui-button-label-color: var(--ui-top-app-bar-medium-leading-icon-color);
    }

    .ui-icon--color-primary {
      --ui-icon-color: var(--ui-top-app-bar-medium-leading-icon-color);
    }

    &:not(:empty) {
      margin-right: calc(var(--ui-sys-unit) * 4);
    }
  }

  .ui-top-app-bar-medium__trailing-icons {
    display: flex;

    .ui-button {
      --ui-button-label-color: var(--ui-top-app-bar-medium-leading-icon-color);
    }

    .ui-icon--color-primary {
      --ui-icon-color: var(--ui-top-app-bar-medium-leading-icon-color);
    }
  }

  .ui-top-app-bar-medium__headline {
    display: flex;
    align-items: center;
    width: 100%;
    font-family: var(--ui-top-app-bar-medium-headline-font);
    font-size: var(--ui-top-app-bar-medium-headline-size);
    line-height: var(--ui-top-app-bar-medium-headline-line-height);
    font-weight: var(--ui-top-app-bar-medium-headline-weight);
    color: hsl(var(--ui-top-app-bar-medium-headline-color));
    margin: 0;
  }
}`;


const $338b2516d28ab608$export$2059614bf6591282 = (0, $790lB$digitalbranchapp.defineComponent)({
    name: 'ui-top-app-bar-medium',
    template: $b48b9edc354fc8ad$export$2e2bcd8739ae039,
    css: $12ba0112ebd8b13f$export$2e2bcd8739ae039
});


var $c47c7e5b32d2db18$exports = {};

$parcel$export($c47c7e5b32d2db18$exports, "uiTopAppBarSmall", () => $c47c7e5b32d2db18$export$b227fda32a853d4d);

var $366931a4cffb560b$export$2e2bcd8739ae039 = /* html */ `
<div class="ui-top-app-bar-small">
  <div class="ui-top-app-bar-small__container">
    <div class="ui-top-app-bar-small__leading-icon">
      <slot name="leading-icon"/>
    </div>
    <div class="ui-top-app-bar-small__headline">
      <slot name="headline"/>
    </div>
    <div class="ui-top-app-bar-small__trailing-icons">
      <slot name="trailing-icon"/>
    </div>
  </div>
  <slot name="divider"/>
</div>
`;


var $18eb700a0831520d$export$2e2bcd8739ae039 = /* css */ `
:host {
  --ui-top-app-bar-small-height: calc(var(--ui-sys-unit) * 64);
  --ui-top-app-bar-small-color: var(--ui-sys-color-surface);
  --ui-top-app-bar-small-container-padding-left: calc(var(--ui-sys-unit) * 16);
  --ui-top-app-bar-small-container-padding-right: calc(var(--ui-sys-unit) * 16);

  --ui-top-app-bar-small-headline-font: var(--ui-sys-typescale-title-large-font-family-name);
  --ui-top-app-bar-small-headline-size: var(--ui-sys-typescale-title-large-font-size);
  --ui-top-app-bar-small-headline-weight: var(--ui-sys-typescale-title-large-font-weight);
  --ui-top-app-bar-small-headline-line-height: var(--ui-sys-typescale-title-large-line-height);
  --ui-top-app-bar-small-headline-color: var(--ui-sys-color-on-surface);

  --ui-top-app-bar-small-leading-icon-color: var(--ui-sys-color-on-surface);
  --ui-top-app-bar-small-trailing-icon-color: var(--ui-sys-color-on-surface);

  display: block;
}

.ui-top-app-bar-small {
  height: var(--ui-top-app-bar-small-height);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 2;

  .ui-top-app-bar-small__container {
    display: flex;
    align-items: center;
    width: 100%;
    height: 100%;
    flex-shrink: 0;
    background-color: hsl(var(--ui-top-app-bar-small-color));
    padding-left: var(--ui-top-app-bar-small-container-padding-left);
    padding-right: var(--ui-top-app-bar-small-container-padding-right);
    z-index: 4;
  }

  .ui-top-app-bar-small__leading-icon {
    .ui-button {
      --ui-button-label-color: var(--ui-top-app-bar-small-leading-icon-color);
    }

    .ui-icon--color-primary {
      --ui-icon-color: var(--ui-top-app-bar-small-leading-icon-color);
    }

    &:not(:empty) {
      margin-right: calc(var(--ui-sys-unit) * 4);
    }
  }

  .ui-top-app-bar-small__trailing-icons {
    display: flex;

    .ui-button {
      --ui-button-label-color: var(--ui-top-app-bar-small-leading-icon-color);
    }

    .ui-icon--color-primary {
      --ui-icon-color: var(--ui-top-app-bar-small-leading-icon-color);
    }
  }

  .ui-top-app-bar-small__headline {
    display: flex;
    align-items: center;
    flex: 1;
    font-family: var(--ui-top-app-bar-small-headline-font);
    font-size: var(--ui-top-app-bar-small-headline-size);
    line-height: var(--ui-top-app-bar-small-headline-line-height);
    font-weight: var(--ui-top-app-bar-small-headline-weight);
    color: hsl(var(--ui-top-app-bar-small-headline-color));
    margin: 0;
  }
}`;


const $c47c7e5b32d2db18$export$b227fda32a853d4d = (0, $790lB$digitalbranchapp.defineComponent)({
    name: 'ui-top-app-bar-small',
    template: $366931a4cffb560b$export$2e2bcd8739ae039,
    css: $18eb700a0831520d$export$2e2bcd8739ae039,
    listeners: {
        ready () {
            const cssCustomPropertyHeight = (this.$node.shadowRoot?.adoptedStyleSheets[0].cssRules[1]).style.getPropertyValue('--ui-top-app-bar-small-height');
            this.$dispatchCustomEvent('custom-property-height', {
                detail: cssCustomPropertyHeight
            });
        }
    }
});


$parcel$exportWildcard($9703e2f3f4452c31$exports, $338b2516d28ab608$exports);
$parcel$exportWildcard($9703e2f3f4452c31$exports, $c47c7e5b32d2db18$exports);


var $f426a6f7e59a728c$exports = {};

$parcel$export($f426a6f7e59a728c$exports, "uiDivider", () => $f426a6f7e59a728c$export$b5d440238a1bb93);

var $8b5cc5ee09d93ef6$export$2e2bcd8739ae039 = /* html */ `
<li
  *if="inList"
  role="separator"
  class="ui-divider ui-divider-list"
  *bind:class="['ui-divider--orientation-' + orientation, 'ui-divider--variant-' + variant]"
></li>
<div
  *else
  role="separator"
  class="ui-divider"
  *bind:class="['ui-divider--orientation-' + orientation, 'ui-divider--variant-' + variant]"
></div>
`;


var $56936e5e3d1ca583$export$2e2bcd8739ae039 = /* css */ `
:host {
  display: block;
}

.ui-divider {
  --ui-divider-color: var(--ui-sys-color-outline-variant);
  --ui-divider-inset-left: 0;
  --ui-divider-inset-right: 0;
  --ui-divider-inset-top: 0;
  --ui-divider-inset-bottom: 0;
  --ui-divider-border-width: calc(var(--ui-sys-unit) * 1);

  margin: 0;

  &.ui-divider--orientation-horizontal {
    border-top-color: hsl(var(--ui-divider-color));
    border-top-width: var(--ui-divider-border-width);
    border-top-style: solid;
    margin: 0;
    margin-top: var(--ui-divider-inset-top);
    margin-bottom: var(--ui-divider-inset-bottom);
    margin-left: var(--ui-divider-inset-left);
    margin-right: var(--ui-divider-inset-right);
  }

  &.ui-divider--orientation-vertical {
    border-top-width: 0;
    border-left-width: var(--ui-divider-border-width);
    border-left-color: hsl(var(--ui-divider-color));
    border-left-style: solid;
    border-right-width: 0;
    border-right-color: var(--ui-divider-color);
    border-right-style: solid;
    border-bottom-width: 0;
    height: 100%;
  }

  &.ui-divider--variant-inset {
    --ui-divider-inset-left: calc(var(--ui-sys-unit) * 16);
    --ui-divider-inset-right: calc(var(--ui-sys-unit) * 16);
  }
}
`;


const $f426a6f7e59a728c$export$b5d440238a1bb93 = (0, $790lB$digitalbranchapp.defineComponent)({
    name: 'ui-divider',
    props: [
        {
            name: 'in-list',
            type: 'boolean',
            default: false
        },
        {
            name: 'orientation',
            type: 'string',
            default: 'horizontal'
        },
        {
            name: 'variant',
            type: 'string',
            default: 'inset'
        }
    ],
    template: $8b5cc5ee09d93ef6$export$2e2bcd8739ae039,
    css: $56936e5e3d1ca583$export$2e2bcd8739ae039
});


var $54616f3c284718ab$exports = {};
var $0b713e5b0391181b$exports = {};

$parcel$export($0b713e5b0391181b$exports, "uiIconButton", () => $0b713e5b0391181b$export$b8ddd9e1a94498);

var $2901ec8635684cc3$exports = {};

$parcel$export($2901ec8635684cc3$exports, "uiRipple", () => $2901ec8635684cc3$export$d39c68a769118bf6);

const $c4d1da2e8514aa7c$export$622cea445a1c5b7d = (node)=>{
    if (!node) return {
        left: 0,
        top: 0
    };
    const { top: top, left: left } = node.getBoundingClientRect();
    return {
        top: top,
        left: left
    };
};


const $0e959aeb6a669d72$export$9b544f58430fc883 = (options = {})=>{
    const { selector: selector = 'body *', ctx: ctx = document.documentElement, refElement: refElement } = options;
    return [
        ...ctx.querySelectorAll(selector)
    ].reduce((acc, element)=>{
        const index = element !== refElement ? parseInt(window.getComputedStyle(element).zIndex, 10) || 0 : 0;
        return index >= acc ? index + 1 : acc;
    }, 0);
};




var $b4cd7e5b1bdf4e39$export$2e2bcd8739ae039 = /* html */ `
<span
  class="ui-ripple ui-sys-state-layer"
  *bind:class="{
    'ui-ripple--is-active': animationActive,
    'ui-ripple--is-deactive': animationDeactive
  }"
  *bind:style="center ?
    { '--ui-ripple-dimension': rippleDim }
     : {
      '--ui-ripple-dimension': rippleDim,
      '--ui-ripple-scale': rippleScale,
      '--ui-ripple-x': pos.x + 'px',
      '--ui-ripple-y': pos.y + 'px'
      }"
  *ref="ripple"
  @mouseDown="onMouseDown"
  @animationEnd="onAnimationEnd"
  @animationStart="onAnimationStart"
>
  <slot></slot>
</span>
`;


var $21054f549a7e18aa$export$2e2bcd8739ae039 = /* css */ `
:host {
  --ui-ripple-x: 50%;
  --ui-ripple-y: 50%;
  --ui-ripple-scale: 1;
  --ui-ripple-start-dimension: 10;
  --ui-ripple-pressed-opacity: var(--ui-sys-state-pressed-state-layer-opacity);
  --ui-ripple-hover-opacity: var(--ui-sys-state-hover-state-layer-opacity);
  --ui-ripple-pressed-color: var(--ui-sys-color-on-surface);
  --ui-ripple-hover-color: var(--ui-sys-color-on-surface);

  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  position: absolute;
  overflow: hidden;
  z-index: 0;
  border-radius: inherit;
  display: block;
  box-sizing: border-box;
}

.ui-sys-state-layer:before {
  --ui-sys-state-layer-color: var(--ui-sys-color-on-primary);
  --ui-sys-state-layer-opacity: 0;

  content: '';
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
  width: 100%;
  height: 100%;
  background-color: hsl(var(--ui-sys-state-layer-color), var(--ui-sys-state-layer-opacity));
  pointer-events: none;
  border-radius: inherit;
}

.ui-ripple {
  width: 100%;
  height: 100%;
  display: block;

  &:hover {
    &.ui-sys-state-layer:before {
      --ui-sys-state-layer-color: var(--ui-ripple-hover-color);
      --ui-sys-state-layer-opacity: var(--ui-ripple-hover-opacity);
    }
  }

  &:after {
    content: '';
    width: 1px;
    height: 1px;
    position: absolute;
    border-radius: 50%;
    left: var(--ui-ripple-x);
    top: var(--ui-ripple-y);
    background-color: hsl(var(--ui-ripple-pressed-color));
    opacity: 0;
    z-index: 0;
  }
}

.ui-ripple--is-active {
  &:after {
    left: var(--ui-ripple-x);
    top: var(--ui-ripple-y);
    animation: 225ms ui-ripple-animation ease-out forwards,
      75ms ui-ripple-opacity-animation forwards;
  }
}

.ui-ripple--is-deactive {
  &:after {
    left: -50%;
    top: -50%;
    width: 200%;
    height: 200%;
    animation: 225ms ui-ripple-opacity-animation-deactive forwards;
  }
}
@keyframes ui-ripple-animation {
    from {
      width: calc(var(--ui-ripple-start-dimension) * 1px);
      height: calc(var(--ui-ripple-start-dimension) * 1px);
    }

    to {
      height: calc(var(--ui-ripple-dimension) * 1px);
      width: calc(var(--ui-ripple-dimension) * 1px);
      transform: translate(
        calc(var(--ui-ripple-dimension) / 2 * -1px),
        calc(var(--ui-ripple-dimension) / 2 * -1px)
      );
    }
  }

  @keyframes ui-ripple-opacity-animation {
    from {
      opacity: 0;
    }

    to {
      opacity: var(--ui-ripple-pressed-opacity);
    }
  }

  @keyframes ui-ripple-opacity-animation-deactive {
    from {
      opacity: var(--ui-ripple-pressed-opacity);
    }

    to {
      opacity: 0;
    }
  }
`;


const $2901ec8635684cc3$export$d39c68a769118bf6 = (0, $790lB$digitalbranchapp.defineComponent)({
    template: $b4cd7e5b1bdf4e39$export$2e2bcd8739ae039,
    css: $21054f549a7e18aa$export$2e2bcd8739ae039,
    props: [
        {
            name: 'center',
            type: 'boolean'
        }
    ],
    data () {
        return {
            center: false,
            pressed: true,
            animationActive: false,
            animationDeactive: false,
            animationActiveEnded: false,
            rippleScale: 1,
            rippleDim: 0,
            pos: {
                x: 0,
                y: 0
            }
        };
    },
    listeners: {
        ready () {
            const { clientWidth: clientWidth, clientHeight: clientHeight } = this.$refs.ripple;
            const curSize = Math.max(clientWidth, clientHeight);
            this.rippleDim = Math.sqrt(Math.pow(curSize, 2) * 2);
            this.rippleScale = 1;
            this.boundFunction = this.onMouseUp.bind(this);
            this.$addEventListener(this.$node, 'mousedown', this.onMouseDown.bind(this));
        },
        beforeDestroy () {
            this.$removeEventListener(this.$node, 'mousedown', this.onMouseDown.bind(this));
        }
    },
    methods: {
        onMouseDown (e) {
            const { button: button } = e;
            const ripple = this.$refs.ripple;
            this.animationActive = false;
            if (ripple) {
                ripple.classList.remove('ui-ripple--is-active');
                const { clientWidth: clientWidth, clientHeight: clientHeight } = ripple;
                const curSize = Math.max(clientWidth, clientHeight);
                const { top: top, left: left } = (0, $c4d1da2e8514aa7c$export$622cea445a1c5b7d)(ripple);
                const { x: pointerX = left, y: pointerY } = e;
                const x = pointerX === 0 ? clientWidth / 2 : pointerX - left;
                const y = pointerY === 0 ? clientHeight / 2 : pointerY - top;
                const scale = 2 - Math.min(Math.min(x, curSize - x), Math.min(y, curSize - y)) / (curSize / 2);
                this.rippleScale = scale;
                this.rippleDim = Math.sqrt(Math.pow(curSize, 2) * 2) * scale;
                this.pos.x = x;
                this.pos.y = y;
            }
            if (button === 0) {
                this.pressed = true;
                this.animationDeactive = false;
                this.animationActiveEnded = false;
                this.animationActive = true;
                window.addEventListener('mouseup', this.boundFunction);
            }
        },
        onMouseUp () {
            this.pressed = false;
            if (this.animationActiveEnded) {
                this.animationDeactive = true;
                this.animationActive = false;
            }
            window.removeEventListener('mouseup', this.boundFunction);
        },
        onAnimationStart (e) {
            if (e.animationName === 'ui-ripple-animation') {
                this.animationActiveEnded = false;
                this.$dispatchCustomEvent('rippleanimationstart');
            }
        },
        onAnimationEnd (e) {
            if (e.animationName === 'ui-ripple-animation') this.$dispatchCustomEvent('rippleanimationend');
            if (e.animationName === 'ui-ripple-animation' && this.animationActive) {
                this.animationActiveEnded = true;
                if (!this.pressed) {
                    this.animationActive = false;
                    this.animationDeactive = true;
                    this.$dispatchCustomEvent('deactive');
                }
            }
            if (e.animationName === 'ui-ripple-opacity-animation-deactive') this.animationDeactive = false;
        }
    }
});




var $8b555fe58be89bec$export$2e2bcd8739ae039 = /* css */ `
:host {
  --focus-ring-outline-opacity: 0;
  --focus-ring-outline-disabled-color: var(--ui-sys-color-on-surface);
  --focus-ring-outline-disabled-opacity: 0.12;
  --focus-ring-outline-width: 0;

  --focus-ring-indicator-color: var(--ui-focus-ring-indicator-color, var(--ui-sys-color-secondary));
  --focus-ring-indicator-thickness: var(--ui-focus-ring-indicator-thickness, var(--ui-sys-state-focus-indicator-thickness));
  --focus-ring-outline-offset: var(--ui-focus-ring-outline-offset, var(--ui-sys-state-focus-indicator-outer-offset));

  --focus-ring-shape: var(--ui-focus-ring-shape, var(--ui-sys-shape-corner-small));

  position: absolute;
  display: none;
  pointer-events: none;
  box-sizing: border-box;
  outline: var(--focus-ring-indicator-thickness) solid hsl(var(--focus-ring-indicator-color));
  outline-offset: var(--focus-ring-outline-offset);
  border-radius: var(--focus-ring-shape);
}

:host([visible]) {
  --focus-ring-outline-opacity: 1;

  display: flex;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}
`;


const $a8f4bbca78a3ef03$export$ab3e879e1ae3ce8a = (0, $790lB$digitalbranchapp.defineComponent)({
    name: 'ui-focus-ring',
    props: [
        {
            name: 'visible',
            type: 'boolean'
        }
    ],
    data () {
        return {
            visible: false
        };
    },
    css: $8b555fe58be89bec$export$2e2bcd8739ae039,
    listeners: {
        ready () {
            this.setVisibility(this.visible);
        },
        attributeChanged (e) {
            const { name: name, value: value } = e;
            if (name === 'visible') this.setVisibility(value !== null);
        }
    },
    methods: {
        setVisibility (state) {
            this.$node.setAttribute('aria-hidden', state ? 'false' : 'true');
        }
    }
});


var $807e1bf52b10984e$export$2e2bcd8739ae039 = /*html*/ `
<ui-focus-ring *bind:visible="hasFocus && showFocusRing ? '' : null"></ui-focus-ring>

<router-link
  class="ui-button"
  *if="to"
  *bind:to="to"
  *bind:type="type"
  *bind:disabled="disabled ? true : null"
  *bind:class="buttonClasses"
  *ref="button"
  @click="handleClick"
  @slotchange="handleSlotChange"
>
  <slot name="ripple"></slot>

  <div class="ui-button-content">
    <span class="ui-button-content__start-icon">
      <slot name="icon-start" />
    </span>

    <div class="ui-button-content__body">
      <slot></slot>
    </div>

    <span class="ui-button-content__end-icon">
      <slot name="icon-end"></slot>
    </span>
  </div>
</router-link>
<button
  class="ui-button"
  *else
  *bind:class="buttonClasses"
  *bind:type="type"
  *bind:disabled="disabled ? '' : null"
  *ref="button"
  @click="handleClick"
  @slotchange="handleSlotChange"
  tabindex="-1"
>
  <slot name="ripple"></slot>

  <div class="ui-button-content">
    <span class="ui-button-content__start-icon">
      <slot name="icon-start"></slot>
    </span>

    <div class="ui-button-content__body">
      <slot></slot>
    </div>

    <span class="ui-button-content__end-icon">
      <slot name="icon-end"></slot>
    </span>
  </div>
</button>
`;


var $4e38321288f2081b$export$2e2bcd8739ae039 = /* css */ `
:host {
  --container-color: var(--ui-button-container-color, none);
  --ui-button-container-shape: var(--ui-sys-shape-corner-small);
  --ui-button-container-height: calc(var(--ui-sys-unit) * 40);
  --ui-button-container-width: auto;
  --ui-button-container-padding-left: calc(var(--ui-sys-unit) * 24);
  --ui-button-container-padding-right: calc(var(--ui-sys-unit) * 24);
  --ui-button-container-padding-top: 0;
  --ui-button-container-padding-bottom: 0;
  --container-opacity: var(--ui-button-container-opacity, 0);

  --focus-ring-indicator-color: var(--ui-button-focus-ring-indicator-color, var(--ui-sys-color-secondary));
  --focus-ring-indicator-thickness: var(--ui-button-focus-ring-indicator-thickness, var(--ui-sys-state-focus-indicator-thickness));
  --focus-ring-outline-offset: var(--ui-button-focus-ring-outline-offset, var(--ui-sys-state-focus-indicator-outer-offset));

  --outline-color: var(var(--ui-button-outline-color), transparent);
  --ui-button-outline-opacity: 0;
  --ui-button-outline-disabled-color: var(--ui-sys-color-on-surface);
  --ui-button-outline-disabled-opacity: 0.12;
  --ui-button-outline-width: 0;

  --ui-button-label-font: var(--ui-sys-typescale-label-large-font-family-name);
  --ui-button-label-color: var(--ui-sys-color-primary);
  --ui-button-label-size: var(--ui-sys-typescale-label-large-font-size);
  --ui-button-label-weight: var(--ui-sys-typescale-label-large-font-weight);
  --ui-button-label-line-height: var(--ui-sys-typescale-label-large-line-height);
  --ui-button-label-tracking: var(--ui-sys-typescale-label-large-letter-spacing);
  --ui-button-label-opacity: 1;

  --ui-button-icon-left-margin: calc(var(--ui-sys-unit) * 8);
  --ui-button-icon-size: calc(var(--ui-sys-unit) * 18);
  --ui-button-icon-disabled-opacity: 1;
  --ui-button-icon-color: var(--ui-sys-color-primary);
  --ui-button-icon-opacity: 1;
  --ui-button-icon-disabled-color: var(--ui-sys-color-on-surface);

  display: inline-flex;
  width: var(--ui-button-container-width);
  min-width: var(--ui-button-container-width);
  height: var(--ui-button-container-height);
  min-height: var(--ui-button-container-height);
  position: relative;
}

::slotted(ui-icon) {
  --ui-icon-color: var(--ui-button-icon-color);
}

ui-focus-ring {
  --ui-focus-ring-shape: var(--ui-button-container-shape);
}

.ui-button {
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  border: none;
  padding:
    var(--ui-button-container-padding-top)
    var(--ui-button-container-padding-right)
    var(--ui-button-container-padding-bottom)
    var(--ui-button-container-padding-left);
  cursor: pointer;
  border-radius: var(--ui-button-container-shape);
  color: hsl(var(--ui-button-label-color), var(--ui-button-label-opacity));
  background-color: hsl(var(--container-color), var(--container-opacity));
  font-family: var(--ui-button-label-font);
  font-size: var(--ui-button-label-size);
  font-weight: var(--ui-button-label-weight);
  line-height: var(--ui-button-label-line-height);
  position: relative;
  border: var(--ui-button-outline-width) solid hsl(var(--outline-color), var(--ui-button-outline-opacity));
  width: 100%;
  height: 100%;
  overflow: hidden;

 &:focus-visible {
  outline: none;
 }

 &[disabled] {
    pointer-events: none;
    ::slotted(ui-ripple) {
      cursor: unset;
    }
  }
}

router-link.ui-button {
  padding: 0;

  --router-link-padding-top: var(--ui-button-container-padding-top);
  --router-link-padding-right:  var(--ui-button-container-padding-right);
  --router-link-padding-bottom:  var(--ui-button-container-padding-bottom);
  --router-link-padding-left:  var(--ui-button-container-padding-left);

}

.ui-button-content {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: inherit;

  .ui-button-content__body {
    display: none;
  }
}

.ui-button--has-icon-start {
  &.ui-button--has-label {
    .ui-button-content__body {
      margin-left: var(--ui-button-icon-left-margin);
    }
  }
}

.ui-button--has-icon-end {
  &.ui-button--has-label,
  &.ui-button--has-icon-start, {
    .ui-button-content__end-icon {
      margin-left: var(--ui-button-icon-left-margin);
    }
  }
}

.ui-button--has-label {
  .ui-button-content__body {
    display: inherit;
    align-items: inherit;
    width: inherit;
    justify-content: inherit;
  }
}

ui-ripple {
  --ui-ripple-pressed-color: var(--ui-sys-color-primary);
  --ui-ripple-hover-color: var(--ui-sys-color-primary);
}
`;


function $24ab93948fb670ad$var$hasNonEmptyChildNodes(slot) {
    return slot.assignedNodes({
        flatten: true
    }).some((node)=>{
        if (node.nodeType === Node.TEXT_NODE) return node.textContent && node.textContent.trim().length > 0;
        return node.nodeType === Node.ELEMENT_NODE;
    });
}
const $24ab93948fb670ad$export$7ece87dcbf135f5e = (0, $790lB$digitalbranchapp.defineComponent)({
    name: 'ui-base-button',
    props: [
        'type',
        {
            name: 'disabled',
            type: 'boolean'
        },
        'to',
        'href'
    ],
    components: {
        uiFocusRing: $a8f4bbca78a3ef03$export$ab3e879e1ae3ce8a
    },
    template: $807e1bf52b10984e$export$2e2bcd8739ae039,
    css: $4e38321288f2081b$export$2e2bcd8739ae039,
    data () {
        return {
            hasIconStart: false,
            hasIconEnd: false,
            hasLabel: false,
            showFocusRing: true,
            hasFocus: false
        };
    },
    formAssociated: true,
    delegatesFocus: true,
    listeners: {
        ready () {
            const { $node: $node } = this;
            const parent = $node.parentNode;
            const host = parent instanceof ShadowRoot ? parent.host : parent;
            $node.setAttribute('tabindex', '0');
            $node.setAttribute('role', this.to || this.href ? 'link' : 'button');
            this.$addEventListener($node, 'focus', this.handleFocus.bind(this));
            this.$addEventListener($node, 'focusout', this.handleFocusOut.bind(this));
            this.$addEventListener($node, 'mousedown', this.handleMouseDown.bind(this));
            this.$addEventListener($node, 'keydown', this.handleKeyDown.bind(this));
            if (host) {
                host.setAttribute('tabindex', '0');
                this.$addEventListener(host, 'focusout', this.handleFocusOutParent.bind(this));
                this.$addEventListener(host, 'keydown', this.keyDownParent.bind(this));
            }
        },
        beforeDestroy () {
            const { $node: $node } = this;
            this.$removeEventListener($node, 'focus', this.handleFocus.bind(this));
            this.$removeEventListener($node, 'focusout', this.handleFocusOut.bind(this));
            this.$removeEventListener($node, 'mousedown', this.handleMouseDown.bind(this));
            this.$removeEventListener($node, 'keydown', this.handleKeyDown.bind(this));
        }
    },
    methods: {
        keyDownParent (e) {
            const { key: key, shiftKey: shiftKey } = e;
            const target = e.currentTarget;
            if (key === 'Tab' && shiftKey) target.setAttribute('tabindex', '-1');
        },
        handleFocusOutParent (e) {
            const target = e.currentTarget;
            target.setAttribute('tabindex', '0');
        },
        handleSlotChange (e) {
            const target = e.target;
            if (!target) return;
            const { name: name, assignedSlot: assignedSlot } = target;
            const hasNodes = $24ab93948fb670ad$var$hasNonEmptyChildNodes(target);
            if (name === 'icon-start' || assignedSlot?.name === 'icon-start') this.hasIconStart = hasNodes;
            else if (name === 'icon-end') this.hasIconEnd = hasNodes;
            else if (name === '') this.hasLabel = hasNodes;
        },
        handleKeyDown (e) {
            const { key: key } = e;
            if (key === 'Enter' || key === ' ') {
                const ripple = this.$node.querySelector('ui-ripple');
                if (ripple) {
                    ripple.dispatchEvent(new MouseEvent('mousedown', {
                        button: 0
                    }));
                    window.dispatchEvent(new MouseEvent('mouseup'));
                }
            }
        },
        handleMouseDown () {
            this.showFocusRing = false;
        },
        handleFocus () {
            this.hasFocus = true;
        },
        handleFocusOut () {
            this.hasFocus = false;
            this.showFocusRing = true;
        },
        handleClick () {
            if (this.type === 'submit') {
                const button = this.$node;
                if (button.form) button.form.dispatchEvent(new Event('submit'));
            }
        }
    },
    computed: {
        buttonClasses () {
            return [
                this.hasLabel && 'ui-button--has-label',
                this.hasIconStart && 'ui-button--has-icon-start',
                this.hasIconEnd && 'ui-button--has-icon-end'
            ];
        }
    }
});


var $08b83d334b88ffad$export$2e2bcd8739ae039 = /* html */ `
<ui-base-button
  class="ui-icon-button"
  *bind:class="buttonClasses"
  *bind:type="type"
  *bind:disabled="disabled ? '' : null"
  *ref="button"
>
  <ui-ripple slot="ripple"></ui-ripple>

  <slot slot="icon-start"></slot>

</ui-base-button>
`;


var $baa22779799540c6$export$2e2bcd8739ae039 = /* css */ `
:host {
  --ui-icon-button-icon-size: calc(var(--ui-sys-unit) * 24);
  --ui-icon-button-icon-opacity: 1;
  --ui-icon-button-icon-color: var(--ui-sys-color-on-surface-variant);

  --ui-icon-button-container-opacity: 1;
  --ui-icon-button-container-height: calc(var(--ui-sys-unit) * 40);
  --ui-icon-button-container-width: calc(var(--ui-sys-unit) * 40);
  --ui-icon-button-container-width: var(--ui-icon-button-container-height);
  --ui-icon-button-container-shape: var(--ui-sys-shape-corner-full);

  --ui-icon-button-outline-width: calc(var(--ui-sys-unit) * 1);
  --ui-icon-button-outline-color: var(--ui-sys-color-outline);

  --button-focus-ring-indicator-color: var(--ui-button-focus-ring-indicator-color, var(--ui-sys-color-secondary));
  --button-focus-ring-indicator-thickness: var(--ui-button-focus-ring-indicator-thickness, var(--ui-sys-state-focus-indicator-thickness));
  --button-focus-ring-outline-offset: var(--ui-button-focus-ring-outline-offset, var(--ui-sys-state-focus-indicator-outer-offset));
}

::slotted(ui-icon) {
  --ui-icon-color: var(--ui-icon-button-icon-color);
  --ui-icon-opacity: var(--ui-icon-button-icon-opacity);
}

ui-base-button {
  --ui-button-container-shape: var(--ui-icon-button-container-shape);
  --ui-button-container-width: var(--ui-icon-button-container-width);
  --ui-button-container-height: var(--ui-icon-button-container-height);
  --ui-button-container-padding-top: 0;
  --ui-button-container-padding-right: 0;
  --ui-button-container-padding-bottom: 0;
  --ui-button-container-padding-left: 0;
}

.ui-icon-button--variant-filled {
  --ui-icon-button-container-color: var(--ui-sys-color-primary);
  --ui-icon-button-icon-color: var(--ui-sys-color-on-primary);
  --ui-ripple-pressed-color: hsl(var(--ui-sys-color-on-primary));

  &:hover {
    &.ui-sys-state-layer:before {
      --ui-sys-state-layer-opacity: var(
        --ui-sys-state-hover-state-layer-opacity
      );
      --ui-sys-state-layer-color: var(--ui-sys-color-on-surface);
    }
  }

  &.ui-icon-button--is-disabled {
    --ui-icon-button-container-color: var(--ui-sys-color-on-surface);
    --ui-icon-button-icon-color: var(--ui-sys-color-on-surface);
  }
}

.ui-icon-button--variant-tonal {
  --ui-icon-button-container-color: var(--ui-sys-color-secondary-container);
  --ui-icon-button-icon-color: var(--ui-sys-color-on-secondary-container);
  --ui-ripple-pressed-color: hsl(var(--ui-sys-color-on-secondary-container));

  &:hover {
    &.ui-sys-state-layer:before {
      --ui-sys-state-layer-opacity: var(
        --ui-sys-state-hover-state-layer-opacity
      );
      --ui-sys-state-layer-color: var(--ui-sys-color-on-secondary-container);
    }
  }

  &.ui-icon-button--is-disabled {
    --ui-icon-button-container-color: var(--ui-sys-color-on-surface);
    --ui-icon-button-icon-color: var(--ui-sys-color-on-surface);
  }
}

.ui-icon-button--variant-outlined {
  --ui-icon-button-icon-color: var(--ui-sys-color-on-surface-variant);
  --ui-ripple-pressed-color: hsl(var(--ui-sys-color-primary));

  border: var(--ui-icon-button-outline-width) solid
    hsla(
      var(--ui-icon-button-outline-color),
      var(--ui-icon-button-container-opacity)
    );

  &:hover {
    &.ui-sys-state-layer:before {
      --ui-sys-state-layer-opacity: var(
        --ui-sys-state-hover-state-layer-opacity
      );
      --ui-sys-state-layer-color: var(--ui-sys-color-primary);
    }
  }

  &.ui-icon-button--is-disabled {
    --ui-icon-button-icon-color: var(--ui-sys-color-on-surface);
    --ui-icon-outline-color: var(--ui-sys-color-on-surface);
  }
}

.ui-icon-button--variant-standard {
  --ui-ripple-pressed-color: hsl(var(--ui-sys-color-primary));
  --ui-icon-button-container-color: transparent;
  --ui-icon-button-icon-color: var(--ui-sys-color-on-surface-variant);

  &:hover {
    &.ui-sys-state-layer:before {
      --ui-sys-state-layer-opacity: var(
        --ui-sys-state-hover-state-layer-opacity
      );
      --ui-sys-state-layer-color: var(--ui-sys-color-on-surface);
    }
  }

  &.ui-icon-button--is-disabled {
    --ui-icon-button-icon-color: var(--ui-sys-color-on-surface);
  }
}

.ui-icon-button--is-disabled {
  --ui-icon-button-container-opacity: 0.12;
  --ui-icon-button-icon-opacity: 0.38;

  cursor: unset;

  &.ui-sys-state-layer:before {
    display: none;
  }
}
`;


const $0b713e5b0391181b$export$b8ddd9e1a94498 = (0, $790lB$digitalbranchapp.defineComponent)({
    name: 'ui-icon-button',
    props: [
        'type',
        {
            name: 'disabled',
            type: 'boolean'
        },
        {
            name: 'variant',
            type: 'string',
            default: 'standard'
        }
    ],
    components: {
        uiBaseButton: $24ab93948fb670ad$export$7ece87dcbf135f5e,
        uiRipple: $2901ec8635684cc3$export$d39c68a769118bf6
    },
    template: $08b83d334b88ffad$export$2e2bcd8739ae039,
    css: $baa22779799540c6$export$2e2bcd8739ae039,
    formAssociated: true,
    delegatesFocus: false,
    listeners: {
        ready () {
            this.$node.setAttribute('role', this.to || this.href ? 'link' : 'button');
            this.$addEventListener(this.$node, 'focus', this.handleFocus.bind(this));
        },
        beforeDestroy () {
            this.$removeEventListener(this.$node, 'focus', this.handleFocus.bind(this));
        }
    },
    methods: {
        handleFocus () {
            this.$refs.button.focus();
        }
    },
    computed: {
        buttonClasses () {
            return [
                `ui-icon-button--variant-${this.variant}`,
                this.disabled && 'ui-icon-button--is-disabled'
            ];
        }
    }
});


var $12d4d55e2d4f5330$exports = {};

$parcel$export($12d4d55e2d4f5330$exports, "uiButton", () => $12d4d55e2d4f5330$export$36a5b2891ceb6ddd);



var $f77869336b3f4333$export$2e2bcd8739ae039 = /*html*/ `
<ui-base-button
  class="ui-button"
  *bind:class="buttonClasses"
  *bind:type="type"
  *bind:disabled="disabled ? true : null"
  *ref="button"
>
  <ui-ripple slot="ripple"></ui-ripple>

  <slot slot="icon-start"></slot>

  <slot slot="icon-end"></slot>
</ui-base-button>`;


var $0d88448e153d9472$export$2e2bcd8739ae039 = /* css */ `
:host {
  --ui-button-label-font: var(--ui-sys-typescale-label-large-font-family-name);
  --ui-button-label-color: var(--ui-sys-color-primary);
  --ui-button-label-size: var(--ui-sys-typescale-label-large-font-size);
  --ui-button-label-weight: var(--ui-sys-typescale-label-large-font-weight);
  --ui-button-label-line-height: var(
    --ui-sys-typescale-label-large-line-height
  );
  --ui-button-label-tracking: var(
    --ui-sys-typescale-label-large-letter-spacing
  );
  --ui-button-label-opacity: 1;
  --ui-button-label-disabled-opacity: 1;
  --ui-button-label-disabled-color: var(--ui-sys-color-on-surface);

  --ui-button-container-height: calc(var(--ui-sys-unit) * 40);
  --ui-button-container-width: auto;
  --ui-button-container-shape: var(--ui-sys-shape-corner-full);
  --ui-button-container-color: transparent;
  --ui-button-container-padding-left: calc(var(--ui-sys-unit) * 24);
  --ui-button-container-padding-right: calc(var(--ui-sys-unit) * 24);
  --ui-button-container-padding-top: 0;
  --ui-button-container-padding-bottom: 0;
  --ui-button-container-disabled-opacity: 1;
  --ui-button-container-opacity: 1;

  --ui-button-icon-left-margin: calc(var(--ui-sys-unit) * 8);
  --ui-button-icon-size: calc(var(--ui-sys-unit) * 18);
  --ui-button-icon-disabled-opacity: 1;
  --ui-button-icon-color: var(--ui-sys-color-primary);
  --ui-button-icon-opacity: 1;
  --ui-button-icon-disabled-color: var(--ui-sys-color-on-surface);

  --ui-button-pressed-state-layer-color: var(--ui-sys-color-primary);
  --ui-button-pressed-state-layer-opacity: var(
    --ui-sys-state-pressed-state-layer-opacity
  );

  --ui-button-outline-color: var(--ui-sys-color-outline);
  --ui-button-oultine-opacity: 1;
  --ui-button-outline-disabled-color: var(--ui-sys-color-on-surface);
  --ui-button-oultine-disabled-opacity: 0.12;
  --ui-button-outline-width: 0;
}

.ui-button {
  cursor: pointer;
  font-size: var(--ui-button-label-size);
  border-radius: var(--ui-button-container-shape);
  background-color: hsl(
    var(--ui-button-container-color),
    var(--ui-button-container-opacity)
  );
  border: var(--ui-button-outline-width) solid
    hsl(var(--ui-button-outline-color), var(--ui-button-oultine-opacity));
  font-family: var(--ui-button-label-font);
  padding-top: var(--ui-button-container-padding-top);
  padding-bottom: var(--ui-button-container-padding-bottom);
  padding-left: var(--ui-button-container-padding-left);
  padding-right: var(--ui-button-container-padding-right);
  font-weight: var(--ui-button-label-weight);
  line-height: var(--ui-button-label-line-height);
  letter-spacing: var(--ui-button-label-tracking);
  color: hsl(var(--ui-button-label-color), var(--ui-button-label-opacity));
  transition: 200ms;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  position: relative;
  z-index: 0;
  width: var(--ui-button-container-width);
  min-width: var(--ui-button-container-width);
  height: var(--ui-button-container-height);
  min-height: var(--ui-button-container-height);

  &:focus,
  &:hover {
    outline: none;
  }

  &.ui-button--has-start-icon {
    --ui-button-container-padding-left: calc(var(--ui-sys-unit) * 16);
  }

  &.ui-sys-state-layer:before {
    transition-timing-function: cubic-bezier(
      var(--ui-sys-motion-easing-standard)
    );
    transition-duration: var(--ui-sys-motion-duration-short4);
    transition-property: background-color;
  }

  .ui-icon {
    --ui-icon-color: var(--ui-button-icon-color);
    --ui-icon-opacity: var(--ui-button-icon-opacity);
    --ui-icon-size: var(--ui-button-icon-size);
  }

  .ui-button-content__start-icon,
  .ui-button-content__end-icon {
    font-size: var(--ui-button-icon-size);
    display: flex;
  }
}

.ui-button-content {
  display: flex;
  align-items: center;
  width: 100%;

  > *:not(:first-child) {
    margin-left: var(--ui-button-icon-left-margin);
  }

  .ui-button-content__body {
    display: inherit;
    align-items: inherit;
    width: inherit;
    justify-content: inherit;
  }
}

.ui-button--variant-filled {
  --ui-button-container-color: var(--ui-sys-color-primary);
  --ui-button-label-color: var(--ui-sys-color-on-primary);
  --ui-button-icon-color: var(--ui-sys-color-on-primary);

  border: none;

  &:hover {
    &.ui-sys-elevation-layer:after {
      --ui-sys-elevation-layer-shadow: var(--ui-sys-elevation-level1-shadow);
    }
  }

  &.ui-button--is-pressed {
    &.ui-sys-elevation-layer:after {
      --ui-sys-elevation-layer-shadow: var(--ui-sys-elevation-level0-shadow);
    }
  }

  &.ui-button--is-disabled {
    --ui-button-container-color: var(--ui-sys-color-on-surface);
    --ui-button-container-disabled-opacity: 0.12;
    --ui-button-label-disabled-opacity: 0.38;
    --ui-button-label-disabled-color: var(--ui-sys-color-on-surface);
    --ui-button-icon-disabled-color: var(--ui-sys-color-on-surface);

    &.ui-sys-elevation-layer:after {
      --ui-sys-elevation-layer-shadow: var(--ui-sys-elevation-level0-shadow);
    }
  }

  ui-ripple {
    --ui-ripple-pressed-color: var(--ui-sys-color-on-primary);
    --ui-ripple-hover-color: var(--ui-sys-color-on-surface);
  }
}

.ui-button--variant-tonal {
  --ui-button-container-color: var(--ui-sys-color-secondary-container);
  --ui-button-icon-color: var(--ui-sys-color-on-secondary-container);

  &:hover {
    &.ui-sys-elevation-layer:after {
      --ui-sys-elevation-layer-shadow: var(--ui-sys-elevation-level1-shadow);
    }
  }

  &.ui-button--is-pressed {
    &.ui-sys-elevation-layer:after {
      --ui-sys-elevation-layer-shadow: var(--ui-sys-elevation-level0-shadow);
    }
  }

  &.ui-button--is-disabled {
    --ui-button-container-color: var(--ui-sys-color-on-surface);
    --ui-button-container-disabled-opacity: 0.12;
    --ui-button-label-disabled-opacity: 0.38;
    --ui-button-label-disabled-color: var(--ui-sys-color-on-surface);
    --ui-button-icon-disabled-color: var(--ui-sys-color-on-surface);

    &.ui-sys-elevation-layer:after {
      --ui-sys-elevation-layer-shadow: var(--ui-sys-elevation-level0-shadow);
    }
  }

  .ui-ripple {
    --ui-ripple-pressed-color: var(--ui-sys-color-on-secondary-container);
    --ui-ripple-hover-color: var(--ui-sys-color-on-secondary-container);
  }
}

.ui-button--variant-elevated {
  --ui-button-container-color: var(--ui-sys-color-surface-container-low);

  &.ui-sys-elevation-layer:after {
    --ui-sys-elevation-layer-shadow: var(--ui-sys-elevation-level1-shadow);
  }

  &:focus,
  &:hover {
    &.ui-sys-elevation-layer:after {
      --ui-sys-elevation-layer-shadow: var(--ui-sys-elevation-level2-shadow);
    }
  }

  &.ui-button--is-disabled {
    --ui-button-container-color: var(--ui-sys-color-on-surface);
    --ui-button-container-disabled-opacity: 0.12;
    --ui-button-label-disabled-opacity: 0.38;
    --ui-button-label-disabled-color: var(--ui-sys-color-on-surface);
    --ui-button-icon-disabled-color: var(--ui-sys-color-on-surface);

    &.ui-sys-elevation-layer:after {
      --ui-sys-elevation-layer-shadow: var(--ui-sys-elevation-level0-shadow);
    }
  }

  &.ui-button--is-pressed {
    &.ui-sys-elevation-layer:after {
      --ui-sys-elevation-layer-shadow: var(--ui-sys-elevation-level1-shadow);
    }
  }

  ui-ripple {
    --ui-ripple-pressed-color: var(--ui-button-pressed-state-layer-color);
    --ui-ripple-pressed-opacity: var(--ui-button-pressed-state-layer-opacity);
  }
}

.ui-button--variant-outlined {
  --ui-button-outline-width: calc(var(--ui-sys-unit) * 1);

  &.ui-button--is-disabled {
    --ui-button-container-color: var(--ui-sys-color-on-surface);
    --ui-button-container-disabled-opacity: 0.12;
    --ui-button-label-disabled-opacity: 0.38;
    --ui-button-label-disabled-color: var(--ui-sys-color-on-surface);
    --ui-button-icon-disabled-color: var(--ui-sys-color-on-surface);

    &.ui-sys-elevation-layer:after {
      --ui-sys-elevation-layer-shadow: var(--ui-sys-elevation-level0-shadow);
    }
  }

  ui-ripple {
    --ui-ripple-pressed-color: var(--ui-sys-color-primary);
  }
}

.ui-button--variant-text {
  &.ui-button--is-disabled {
    --ui-button-container-disabled-opacity: 0.12;
    --ui-button-label-disabled-opacity: 0.38;
    --ui-button-label-disabled-color: var(--ui-sys-color-on-surface);
    --ui-button-icon-disabled-color: var(--ui-sys-color-on-surface);

    &.ui-sys-elevation-layer:after {
      --ui-sys-elevation-layer-shadow: var(--ui-sys-elevation-level0-shadow);
    }
  }

  ui-ripple {
    --ui-ripple-pressed-color: var(--ui-sys-color-primary);
    --ui-ripple-hover-color: var(--ui-sys-color-on-surface);
  }
}

.ui-button--is-disabled {
  --ui-button-container-color: var(--ui-button-container-disabled-color);
  --ui-button-container-opacity: var(--ui-button-container-disabled-opacity);
  --ui-button-label-color: var(--ui-button-label-disabled-color);
  --ui-button-icon-color: var(--ui-button-icon-disabled-color);
  --ui-button-icon-opacity: var(--ui-button-icon-disabled-opacity);
  --ui-button-label-opacity: var(--ui-button-label-disabled-opacity);
  --ui-button-outline-color: var(--ui-button-oultine-disabled-color);
  --ui-button-outline-opacity: var(--ui-button-oultine-disabled-opacity);

  cursor: unset;
}
`;


const $12d4d55e2d4f5330$export$36a5b2891ceb6ddd = (0, $790lB$digitalbranchapp.defineComponent)({
    name: 'ui-button',
    props: [
        'type',
        {
            name: 'disabled',
            type: 'boolean'
        },
        {
            name: 'variant',
            type: 'string',
            default: 'filled'
        }
    ],
    components: {
        uiRipple: $2901ec8635684cc3$export$d39c68a769118bf6,
        uiBaseButton: $24ab93948fb670ad$export$7ece87dcbf135f5e
    },
    template: $f77869336b3f4333$export$2e2bcd8739ae039,
    css: $0d88448e153d9472$export$2e2bcd8739ae039,
    formAssociated: true,
    delegatesFocus: false,
    listeners: {
        ready () {
            this.$node.setAttribute('tabindex', '0');
            this.$node.setAttribute('role', this.to || this.href ? 'link' : 'button');
            this.$addEventListener(this.$node, 'focus', this.handleFocus.bind(this));
        },
        beforeDestroy () {
            this.$node.removeEventListener('focus', this.boundHandleFocus);
        }
    },
    methods: {
        handleFocus () {
            this.$refs.button.focus();
        }
    },
    computed: {
        buttonClasses () {
            return [
                `ui-icon-button--variant-${this.variant}`,
                this.disabled && 'ui-icon-button--is-disabled'
            ];
        }
    }
});


$parcel$exportWildcard($54616f3c284718ab$exports, $0b713e5b0391181b$exports);
$parcel$exportWildcard($54616f3c284718ab$exports, $12d4d55e2d4f5330$exports);


var $c4102ef8d2d773ae$exports = {};

$parcel$export($c4102ef8d2d773ae$exports, "uiIcon", () => $c4102ef8d2d773ae$export$3ce8277576dc8eb2);

var $f308a8e2359e114e$export$2e2bcd8739ae039 = /* html */ `
<span class="icon material-symbols-outlined" *bind:class="{ loading: loading }">{{icon}}</span>
`;


var $47a34e4ea123b588$export$2e2bcd8739ae039 = /* css */ `
:host {
  --ui-icon-size: calc(var(--ui-sys-unit) * 24);
  --ui-icon-color: var(--ui-sys-color-primary);
  --ui-icon-opacity: 1;
  --ui-icon-fill: 1;

  width: var(--ui-icon-size);
  height: var(--ui-icon-size);
  overflow: hidden;
  display: block;
}

.loading {
  visibility: hidden;
}

.material-symbols-outlined {
  font-family: 'Material Symbols Outlined';
  font-weight: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: normal;
  text-transform: none;
  display: inline-block;
  white-space: nowrap;
  word-wrap: normal;
  direction: ltr;
  -webkit-font-feature-settings: 'liga';
  -webkit-font-smoothing: antialiased;

  font-variation-settings:
  'FILL' var(--ui-icon-fill),
  'wght' 400,
  'GRAD' 0,
  'opsz' 24;

  color: hsl(var(--ui-icon-color), var(--ui-icon-opacity));
  font-size: var(--ui-icon-size);
  height: 100%;
  width: 100%;
}

.material-symbols-outlined {
}

:host([fill="0"]) {
  --ui-icon-fill: 0;
}
`;



const $c4102ef8d2d773ae$export$3ce8277576dc8eb2 = (0, $790lB$digitalbranchapp.defineComponent)({
    name: 'ui-icon',
    template: $f308a8e2359e114e$export$2e2bcd8739ae039,
    css: $47a34e4ea123b588$export$2e2bcd8739ae039,
    props: [
        'icon',
        'fill'
    ],
    components: {
        uiBaseButton: $24ab93948fb670ad$export$7ece87dcbf135f5e
    },
    inject: [
        'icons'
    ],
    data () {
        return {
            icon: '',
            fill: 1,
            loading: true
        };
    },
    listeners: {
        async compiled () {
            await this.addFont();
            this.setState();
        }
    },
    methods: {
        async setState () {
            await document.fonts.load('24px "Material Symbols Outlined"');
            this.loading = false;
        },
        async addFont () {
            return new Promise((resolve)=>{
                const id = `ui-icon-font`;
                const currentStyle = document.getElementById(id);
                if (currentStyle && currentStyle.dataset.loaded !== undefined) resolve();
                else if (currentStyle) currentStyle.addEventListener('load', async ()=>{
                    requestAnimationFrame(()=>{
                        resolve();
                    });
                });
                else {
                    const { icons: icons } = this;
                    const style = document.createElement('link');
                    style.id = id;
                    style.setAttribute('href', `https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200&icon_names=${icons.sort((a, b)=>a.localeCompare(b)).join(',')}&display=block`);
                    style.setAttribute('rel', 'stylesheet');
                    style.addEventListener('load', async ()=>{
                        requestAnimationFrame(()=>{
                            style.dataset.loaded = '';
                            resolve();
                        });
                    });
                    document.head.appendChild(style);
                }
            });
        }
    }
});



var $b7a7a0ec9978f890$exports = {};

$parcel$export($b7a7a0ec9978f890$exports, "uiNavigationDrawer", () => $b7a7a0ec9978f890$export$bdf796bae0651ca3);

var $c8fb3bfc7412319f$export$2e2bcd8739ae039 = /* html */ `
<nav
  *ref="drawer"
  class="ui-navigation-drawer"
  *bind:class="drawerClasses"
  *bind:style="{
    zIndex: zIndex
  }"
  *bind:aria-hidden="type === 'modal' && !open"
  *bind:inert="type === 'modal' && !open ? true : null"
>
  <div
    id="ui-navigation-drawer"
    class="ui-navigation-drawer__container"
  >
    <div class="ui-navigation-drawer__body">
      <slot/>
    </div>
    <slot name="divider"/>
  </div>
  <div
    *if="type === 'modal' && open"
    class="ui-navigation-drawer__scrim"
    @click="handleClose"
    role="button"
  ></div>
</nav>
`;


var $b81ee5fbb8c5f27a$export$2e2bcd8739ae039 = /* css */ `
:host {
  --ui-navigation-drawer-container-width: calc(var(--ui-sys-unit) * 360);
  --ui-navigation-drawer-container-height: 100%;
  --ui-navigation-drawer-container-shape: 0;
  --ui-navigation-drawer-container-elevation: var(
    --ui-sys-elevation-level0-shadow
  );
  --ui-navigation-drawer-container-padding-left: calc(
    var(--safe-area-inset-left) + var(--ui-sys-unit) * 10
  );
  --ui-navigation-drawer-container-padding-right: calc(var(--ui-sys-unit) * 10);
  --ui-navigation-drawer-container-padding-top: calc(
    var(--safe-area-inset-top) + var(--ui-sys-unit) * 16
  );
  --ui-navigation-drawer-container-padding-bottom: calc(
    var(--safe-area-inset-bottom) + var(--ui-sys-unit) * 16
  );
  --ui-navigation-drawer-container-background-color: hsl(
    var(--ui-sys-color-surface)
  );
  --ui-navigation-drawer-container-surface-tint-color: hsl(
    var(--ui-sys-color-surface-tint)
  );
  --ui-navigation-drawer-container-elevation: var(
    --ui-sys-elevation-level0-opacity
  );

  view-transition-name: none;
}

::slotted(*) {
  max-width: 100%;
}

.ui-navigation-drawer {
  width: var(--ui-navigation-drawer-container-width);
  height: var(--ui-navigation-drawer-container-height);
}

.ui-divider {
  --ui-divider-inset-top: calc(var(--ui-sys-unit) * 8);
  --ui-divider-inset-bottom: calc(var(--ui-sys-unit) * 8);
  --ui-divider-inset-left: calc(var(--ui-sys-unit) * 16);
  --ui-divider-inset-right: calc(var(--ui-sys-unit) * 16);
}

.ui-navigation-drawer__container {
  width: var(--ui-navigation-drawer-container-width);
  height: var(--ui-navigation-drawer-container-height);
  display: flex;
  overflow: hidden;
  z-index: 2;
  background-color: var(--ui-navigation-drawer-container-background-color);
  border-radius: 0 var(--ui-navigation-drawer-container-shape) var(--ui-navigation-drawer-container-shape) 0;
  overflow: hidden;

  .ui-navigation-drawer__body {
    display: flex;
    flex: 1;
    flex-direction: column;
    padding-top: var(--ui-navigation-drawer-container-padding-top);
    padding-left: var(--ui-navigation-drawer-container-padding-left);
    padding-right: var(--ui-navigation-drawer-container-padding-right);
    padding-bottom: var(--ui-navigation-drawer-container-padding-bottom);
    overflow-y: auto;
    scrollbar-color: hsl(var(--ui-sys-color-primary)) transparent;
    scrollbar-width: thin;

    .ui-button {
      justify-content: flex-start;
    }
  }

  .ui-navigation-drawer__menu {
    --ui-button-label-color: hsl(var(--ui-sys-color-on-surface-variant));

    margin-left: var(--offset-3);
    margin-bottom: var(--spacing-3);
    margin-top: var(--spacing-1);
    flex: 0;
  }
}

.ui-navigation-drawer__scrim {
  background-color: hsl(var(--ui-sys-color-scrim));
  cursor: pointer;
  z-index: 1;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease, visibility 0s ease 0.3s;
  display: block;
}

.ui-navigation-drawer-modal {
  --ui-navigation-drawer-container-shape: var(--ui-sys-shape-corner-large);

  position: fixed;
  z-index: 2;
  pointer-events: none;

  .ui-navigation-drawer__container {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    overflow: hidden;
    transition: transform 0.3s cubic-bezier(0, 0, 0.2, 1);
    transform: translate(-100%, 0);

    > .ui-divider {
      display: none;
    }
  }
}

.ui-navigation-drawer-standard {
  transition: width 0.2s;

  .ui-navigation-drawer__container {
    transition: width 0.2s;
  }
}

.ui-navigation-drawer-standard--is-collapsed {
  --ui-navigation-drawer-container-width: calc(var(--ui-sys-unit) * 77);
  --ui-navigation-drawer-container-padding-left: 0;
  --ui-navigation-drawer-container-padding-right: 0;
  --ui-navigation-drawer-container-padding-top: calc(
    var(--safe-area-inset-top) + var(--ui-sys-unit) * 16
  );

  .ui-navigation-drawer__body {
    align-items: center;
  }
}

.ui-navigation-drawer-modal--is-open {
  pointer-events: initial;

  .ui-navigation-drawer__container {
    transform: translate(0, 0);
    box-shadow: var(--ui-navigation-drawer-container-elevation);
  }

  .ui-navigation-drawer__scrim {
    pointer-events: auto;
    opacity: 1;
    visibility: visible;
    transition: opacity 0.3s ease;
  }
}
`;


const $b7a7a0ec9978f890$export$bdf796bae0651ca3 = (0, $790lB$digitalbranchapp.defineComponent)({
    name: 'ui-navigation-drawer',
    props: [
        {
            name: 'type',
            type: 'string',
            default: 'standard'
        },
        {
            name: 'open',
            type: 'boolean'
        }
    ],
    template: $c8fb3bfc7412319f$export$2e2bcd8739ae039,
    css: $b81ee5fbb8c5f27a$export$2e2bcd8739ae039,
    data () {
        return {
            zIndex: 3
        };
    },
    listeners: {
        attributeChanged ({ name: name, value: value }) {
            if (name === 'open') {
                if (value !== null) {
                    document.body.classList.add('ui-navigation-drawer--is-open');
                    this.zIndex = this.type === 'modal' ? 9999 : 3;
                } else {
                    document.body.classList.remove('ui-navigation-drawer--is-open');
                    this.zIndex = 3;
                }
            }
        }
    },
    methods: {
        handleClose () {
            this.$dispatchCustomEvent('close');
        }
    },
    computed: {
        drawerClasses () {
            return [
                this.type === 'modal' ? 'ui-navigation-drawer-modal' : 'ui-navigation-drawer-standard',
                this.type === 'standard' ? this.open ? 'ui-navigation-drawer-standard--is-expaned' : 'ui-navigation-drawer-standard--is-collapsed' : null,
                this.type === 'modal' && this.open && 'ui-navigation-drawer-modal--is-open'
            ];
        }
    }
});


var $e0bf9c330ac08625$exports = {};

$parcel$export($e0bf9c330ac08625$exports, "uiNavigationDrawerButton", () => $e0bf9c330ac08625$export$34dccadd02308eb5);


var $0505bf500cf8ef25$export$2e2bcd8739ae039 = /* html */ `
<ui-base-button
  class="ui-navigation-drawer-button"
  *bind:class="[
    hasLabel && 'ui-navigation-drawer-button--has-label',
    hasIcon && 'ui-navigation-drawer-button--has-icon',
    active && 'ui-navigation-drawer-button--active'
  ]"
  *bind:to="to"
  *bind:to="href"
  @click="handleClick"
  @slotchange="onSlotChange"
  @routerlinkactive.custom="onRouterLinkActive"
>
  <slot name="icon" slot="icon-start"></slot>

  <div class="ui-navigation-drawer-button__container">
    <div
      class="ui-navigation-drawer-button__content"
      *bind:class="{ 'ui-navigation-drawer-button__content--icon-placement-left': hasIcon }"
    >
      <span class="ui-navigation-drawer-button__text">
        <slot></slot>
      </span>
    </div>
  </div>
</ui-base-button>`;


var $7d7b574cfeadfdb4$export$2e2bcd8739ae039 = /* css */ `
:host {
  --ui-navigation-button-container-color: transparent;
  --ui-navigation-drawer-button-text-color: var(--ui-sys-color-on-surface-variant);
  --ui-navigation-drawer-button-text-weight: var(--ui-sys-typescale-label-large-font-weight);
  --ui-navigation-drawer-button-text-size: var(--ui-sys-typescale-label-large-font-size);
  --ui-navigation-drawer-button-container-shape: calc(var(--ui-sys-unit) * 28);
  --ui-navigation-drawer-button-active-indicator-height: calc(var(--ui-sys-unit) * 56);
  --ui-navigation-drawer-button-active-indicator-padding: calc(var(--ui-sys-unit) * 12);
  --ui-navigation-drawer-button-icon-size: calc(var(--ui-sys-unit) * 24);
  --ui-navigation-drawer-button-inactive-icon-color: var(--ui-sys-color-on-surface-variant);
  --ui-navigation-drawer-button-active-icon-color: var(--ui-sys-color-on-secondary-container);
  --ui-navigation-button-container-opacity: 0;

  display: block;
  width: 100%;
}

ui-base-button {
  --ui-button-container-color: var(--ui-navigation-button-container-color);
  --ui-button-container-shape: var(--ui-navigation-drawer-button-container-shape);
  --ui-button-container-height: var(--ui-navigation-drawer-button-active-indicator-height);
  --ui-button-container-width: 100%;
  --ui-button-container-opacity: var(--ui-navigation-button-container-opacity);

  --ui-button-label-font: var(--ui-sys-typescale-label-large-font-family-name);
  --ui-button-label-color: var(--ui-navigation-drawer-button-text-color);
  --ui-button-label-size: var(--ui-navigation-drawer-button-text-size);
  --ui-button-label-weight: var(--ui-navigation-drawer-button-text-weight);

  --ui-button-icon-color: var(--ui-navigation-drawer-button-active-icon-color);

  &.active,
  &.ui-navigation-drawer-button--active {
    --ui-navigation-drawer-button-text-color: var(--ui-sys-color-on-secondary-container);

    --ui-navigation-button-container-color: var(--ui-sys-color-secondary-container);
    --ui-navigation-button-container-opacity: 1;

    &:hover {
      &.ui-sys-state-layer:before {
        --ui-sys-state-layer-color: var(--ui-sys-color-secondary-container);
      }

      &.ui-sys-elevation-layer:after {
        --ui-sys-elevation-layer-shadow: var(--ui-sys-elevation-level0-shadow);
      }
    }

    .ui-icon {
      --ui-icon-color: var(--ui-navigation-drawer-button-active-icon-color);
    }
  }

  &:hover {
    &.ui-sys-state-layer:before {
      --ui-sys-state-layer-opacity: var(
        --ui-sys-state-hover-state-layer-opacity
      );
      --ui-sys-state-layer-color: var(--ui-sys-color-on-surface);
    }

    &.ui-sys-elevation-layer:after {
      --ui-sys-elevation-layer-shadow: var(--ui-sys-elevation-level0-shadow);
    }
  }

  .ui-navigation-drawer-button__text {
    white-space: nowrap;
  }

  .ui-button-content {
    --ui-button-icon-left-margin: var(
      --ui-navigation-drawer-button-active-indicator-padding
    );

    --ui-button-icon-size: var(--ui-navigation-drawer-button-icon-size);
  }
}
`;


const $e0bf9c330ac08625$export$34dccadd02308eb5 = (0, $790lB$digitalbranchapp.defineComponent)({
    name: 'ui-navigation-drawer-button',
    props: [
        {
            name: 'active',
            type: 'boolean'
        },
        'to',
        'href',
        'active'
    ],
    components: {
        uiBaseButton: $24ab93948fb670ad$export$7ece87dcbf135f5e
    },
    template: $0505bf500cf8ef25$export$2e2bcd8739ae039,
    css: $7d7b574cfeadfdb4$export$2e2bcd8739ae039,
    data () {
        return {
            hasIcon: false,
            hasLabel: true,
            active: false
        };
    },
    methods: {
        onSlotChange (e) {
            const target = e.target;
            const { name: name } = target;
            const hasNodes = target.assignedNodes().length > 0;
            if (name === '') this.hasLabel = hasNodes;
            else if (name === 'icon-start') this.hasIcon = hasNodes;
        },
        onRouterLinkActive (e) {
            this.active = e.detail;
        }
    }
});


var $2424a852aecdbf67$exports = {};

$parcel$export($2424a852aecdbf67$exports, "uiNavigationRailButton", () => $2424a852aecdbf67$export$3ab9d021c1445f65);


var $d4009b824d1fa391$export$2e2bcd8739ae039 = /* html */ `
<ui-base-button
  class="ui-navigation-rail-button"
  *bind:to="to"
  *bind:href="href"
  *bind:ripple="false"
  *bind:class="buttonClasses"
  @click="handleClick"
  *ref="buttonRef"
  @slotchange="onSlotChange"
  @routerlinkactive.custom="onRouterLinkActive"
>
  <div class="ui-navigation-rail-button__container">
    <div
      class="ui-navigation-rail-button__content"
      *bind:class="{
        'ui-navigation-rail-button__content--icon-placement-top': hasIcon
      }"
    >
      <span class="ui-navigation-rail-button__icon">
        <slot name="icon"></slot>
      </span>

      <span class="ui-navigation-rail-button__text">
        <slot></slot>
      </span>

    </div>
  </div>
</ui-base-button>
`;


var $c9a270299e3b45ec$export$2e2bcd8739ae039 = /* css */ `
:host {
  --ui-navigation-rail-button-text-size: var(--ui-sys-typescale-label-medium-font-size);
  --ui-navigation-rail-label-tracking: var(--ui-sys-typescale-label-medium-tracking);
  --ui-navigation-rail-button-text-line-height: var(--ui-sys-typescale-label-medium-line-height);
  --ui-navigation-rail-button-text-inactive-color: var(--ui-sys-color-on-surface-variant);
  --ui-navigation-rail-button-text-active-color: var(--ui-sys-color-on-surface);
  --ui-navigation-rail-button-text-weight: var(--ui-sys-typescale-label-medium-font-weight);
  --ui-navigation-rail-button-active-indicator-color: var(--ui-sys-color-secondary-container);
  --ui-navigation-rail-button-icon-inactive-color: var(--ui-sys-color-on-surface-variant);
  --ui-navigation-rail-button-icon-active-color: var(--ui-sys-color-on-secondary-container);

  --ui-navigation-rail-button-state-layer-color: var(--ui-sys-color-on-surface-variant);
  --ui-navigation-rail-button-state-layer-opacity: 0;
  --ui-navigation-rail-button-height: calc(var(--ui-sys-unit) * 56);
  --ui-navigation-rail-button-spacing: calc(var(--ui-sys-unit) * 12);
}

.ui-navigation-rail-button {
  display: flex;
  height: var(--ui-navigation-rail-button-height);
  flex: 1;
  color: hsl(var(--ui-navigation-rail-button-text-inactive-color));
  max-height: var(--ui-navigation-rail-button-height);

  ::slotted(ui-icon) {
    --ui-icon-color: var(--ui-navigation-rail-button-icon-inactive-color);

    z-index: 0;
  }

  ui-ripple {
    --ui-sys-elevation-layer-shadow: var(--ui-sys-elevation-level0-shadow);
  }

  &.ui-navigation-rail-button--has-label {
    &:not(:last-child) {
      margin-bottom: var(--ui-navigation-rail-button-spacing);
    }

    .ui-navigation-rail-button__icon {
      margin-bottom: 4px;
    }
  }

  &:hover {

      --ui-navigation-rail-button-state-layer-opacity: var(--ui-sys-state-hover-state-layer-opacity);


    ui-ripple {
      --ui-sys-state-layer-opacity: 0;
    }
  }

  &:hover,
  &.ui-navigation-rail-button--is-active {
    --ui-navigation-rail-button-text-weight: var(--ui-sys-typescale-label-medium-font-weight-prominent);

    color: hsl(var(--ui-navigation-rail-button-text-active-color));

    .ui-navigation-rail-button__icon::before {
      transform: scale(1, 1);
      opacity: 1;
    }

    ::slotted(ui-icon) {
      --ui-icon-color: var(--ui-navigation-rail-button-icon-active-color);
    }

    &.ui-sys-elevation-layer:after {
      --ui-sys-elevation-layer-shadow: var(--ui-sys-elevation-level0-shadow);
    }
  }

  .ui-navigation-rail-button__icon {
    &::before {
      content: '';
      width: 100%;
      height: 100%;
      border-radius: 16px;
      opacity: 0;
      top: 0;
      z-index: 0;
      display: block;
      position: absolute;
      transform: scale(0, 1);
      transition: 0.15s ease-out;
      pointer-events: none;
      background-color: hsl(var(--ui-navigation-rail-button-active-indicator-color));
    }

    &::after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      z-index: 0;
      width: 100%;
      height: 100%;
      display: block;
      pointer-events: none;
      opacity: var(--ui-navigation-rail-button-state-layer-opacity);
      border-radius: 16px;
      background-color: hsl(var(--ui-navigation-rail-button-state-layer-color));
      transition: 0.15s ease-out;
    }
  }

  &:focus,
  &:focus-within,
  &:hover {
    box-shadow: none;
  }
}

.ui-navigation-rail-button__icon {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 32px;
}

.ui-navigation-rail-button__content {
  padding-top: var(--ui-navigation-rail-button-padding-top);
  padding-bottom: var(--ui-navigation-rail-button-padding-bottom);
  display: flex;
  align-items: center;
  justify-content: center;
}

.ui-navigation-rail-button__content--icon-placement-top {
  flex-direction: column;
}

.ui-navigation-rail-button .ui-navigation-rail-button__text {
  font-size: var(--ui-navigation-rail-button-text-size);
  line-height: var(--ui-navigation-rail-button-text-line-height);
  letter-spacing: var(--ui-navigation-rail-label-tracking);
  white-space: nowrap;
  font-weight: var(--ui-navigation-rail-button-text-weight);
}

.ui-navigation-rail-button__container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  position: relative;
  pointer-events: none;
}
`;


const $2424a852aecdbf67$export$3ab9d021c1445f65 = (0, $790lB$digitalbranchapp.defineComponent)({
    name: 'ui-navigation-rail-button',
    props: [
        {
            name: 'active',
            type: 'boolean'
        },
        'to',
        'href',
        'active'
    ],
    components: {
        uiBaseButton: $24ab93948fb670ad$export$7ece87dcbf135f5e
    },
    template: $d4009b824d1fa391$export$2e2bcd8739ae039,
    css: $c9a270299e3b45ec$export$2e2bcd8739ae039,
    data () {
        return {
            hasLabel: true,
            hasIcon: false,
            active: false
        };
    },
    computed: {
        buttonClasses () {
            return [
                this.hasLabel && 'ui-navigation-rail-button--has-label',
                this.hasIcon && `ui-navigation-rail-button--has-icon`,
                this.active && 'ui-navigation-rail-button--is-active'
            ];
        }
    },
    methods: {
        onSlotChange (e) {
            const { target: target } = e;
            const { name: name } = target;
            const hasNodes = target.assignedNodes().length > 0;
            if (name === undefined) this.hasLabel = hasNodes;
            else if (name === 'icon') this.hasIcon = hasNodes;
        },
        onRouterLinkActive (e) {
            this.active = e.detail;
        }
    }
});


var $b86cefd5916fc45e$exports = {};

$parcel$export($b86cefd5916fc45e$exports, "uiNavigationRail", () => $b86cefd5916fc45e$export$3094b5c5e77f5dba);

var $56da3e0c7f9a0ecc$export$2e2bcd8739ae039 = /* html */ `
<nav class="ui-navigation-rail">
  <div class="ui-navigation-rail__container">
    <div class="ui-navigation-rail__top-buttons">
      <div class="ui-navigation-rail__menu-button">
        <slot name="menu-button"></slot>
      </div>
      <div class="ui-navigation-rail__fab">
        <slot name="fab"></slot>
      </div>
    </div>
    <slot></slot>
  </div>
  <slot name="divider"></slot>
</nav>`;


var $73b38ed1a074fe82$export$2e2bcd8739ae039 = /* css */ `
:host {
  --ui-navigation-rail-padding-top: calc(var(--safe-area-inset-top) + var(--ui-sys-unit) * 16);
  --ui-navigation-rail-container-color: hsl(var(--ui-sys-color-surface));
  --ui-navigation-rail-container-width: calc(var(--ui-sys-unit) * 80);

  --ui-navigation-rail-container-height: 100%;
  --ui-navigation-rail-button-spacing: calc(var(--ui-sys-unit) * 12);
  --ui-navigation-rail-color: hsl(var(--ui-sys-color-surface));

  --ui-navigation-rail-surface-color: hsl(var(--ui-sys-color-surface-tint), var(--ui-sys-elevation-level0-opacity));
  --ui-navigation-rail-top-buttons-margin-bottom: calc(var(--ui-sys-unit) * 48);
  --ui-navigation-rail-top-buttons-min-height: calc(var(--ui-sys-unit) * 64);
}

.ui-navigation-rail {
  display: flex;
  height: var(--ui-navigation-rail-container-height);

  .ui-navigation-rail__container {
    height: var(--ui-navigation-rail-container-height);
    min-width: var(--ui-navigation-rail-container-width);
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    z-index: 1;
    background-color: var(--ui-navigation-rail-container-color);
    padding-left: var(--safe-area-inset-left);
    padding-top: var(--ui-navigation-rail-padding-top);
  }

  .ui-navigation-rail__top-buttons {
    margin-bottom: var(--ui-navigation-rail-top-buttons-margin-bottom);

    .ui-fab {
      &.ui-sys-elevation-layer:after {
        --ui-sys-elevation-layer-shadow: var(--ui-sys-elevation-level0-shadow);
      }
    }

    .ui-navigation-rail__menu-button {
      display: flex;
      justify-content: center;

      &:not(:last-child):not(:empty) {
        margin-bottom: var(--ui-navigation-rail-button-spacing);
      }
    }
  }
}
`;


const $b86cefd5916fc45e$export$3094b5c5e77f5dba = (0, $790lB$digitalbranchapp.defineComponent)({
    name: 'ui-navigation-rail',
    template: $56da3e0c7f9a0ecc$export$2e2bcd8739ae039,
    css: $73b38ed1a074fe82$export$2e2bcd8739ae039,
    listeners: {
        attributeChanged ({ name: name, value: value }) {}
    },
    methods: {
        handleClose () {
            this.$dispatchCustomEvent('close');
        }
    }
});


var $6bf427624d708ac0$exports = {};

$parcel$export($6bf427624d708ac0$exports, "uiGrid", () => $6bf427624d708ac0$export$80fd1d62079e13a6);

var $e5e836ef422e1f2c$export$2e2bcd8739ae039 = /* css */ `
:host([container]){
  display: flex;
}

/*  direction: 'row' | 'row-reverse' | 'column' | 'column-reverse' */
:host([container][direction="column"]){
  flex-wrap: nowrap;
  flex-direction: column;
}

:host([container][direction="row"]){
  flex-direction: row;
}

:host([container][direction="row-reverse"]){
  flex-direction: row-reverse;
}

:host([container][direction="column-reverse"]){
  flex-direction: column-reverse;
}

/* alignItems: 'flex-start' | 'flex-end' | 'stretch' | 'center' | 'baseline' */
:host([container][align-items="flex-start"]){
  align-items: flex-start;
}

:host([container][align-items="flex-end"]){
  align-items: flex-end;
}

:host([container][align-items="stretch"]){
  align-items: stretch;
}

:host([container][align-items="center"]){
  align-items: center;
}

:host([container][align-items="baseline"]){
  align-items: baseline;
}

/* justifyContent: 'flex-start' | 'flex-end' | 'center' | 'space-between' | 'space-around' | 'space-evenly' | 'stretch' */
:host([container][justify-content="flex-start"]){
  justify-content: flex-start;
}

:host([container][justify-content="flex-end"]){
  justify-content: flex-end;
}

:host([container][justify-content="center"]){
  justify-content: center;
}

:host([container][justify-content="space-between"]){
  justify-content: space-between;
}

:host([container][justify-content="space-around"]){
  justify-content: space-around;
}

:host([container][justify-content="space-evenly"]){
  justify-content: space-evenly;
}

:host([container][justify-content="strech"]){
  justify-content: stretch;
}

/* flexWrap: 'wrap' | 'nowrap' | 'wrap-reverse' */
:host([container][flex-wrap="wrap"]){
  flex-wrap: wrap;
}

:host([container][flex-wrap="nowrap"]){
  flex-wrap: nowrap;
}

:host([container][flex-wrap="wrap-reverse"]){
  flex-wrap: wrap-reverse;
}

:host([spacing="1"]) {
  --ui-grid-spacing: calc(var(--ui-sys-unit) * 8);

  margin-left: calc(-1 * var(--ui-grid-spacing));
  margin-top: calc(-1 * var(--ui-grid-spacing));

  max-width: calc(100% + var(--ui-grid-spacing));
  max-height: calc(100% + var(--ui-grid-spacing));

  > ::slotted([item]) {
    padding-left: var(--ui-grid-spacing);
    padding-top: var(--ui-grid-spacing);
  }
}

:host([spacing="2"]) {
  --ui-grid-spacing: calc(var(--ui-sys-unit) * 16);

  margin-left: calc(-1 * var(--ui-grid-spacing));
  margin-top: calc(-1 * var(--ui-grid-spacing));

  max-width: calc(100% + var(--ui-grid-spacing));
  max-height: calc(100% + var(--ui-grid-spacing));

  > ::slotted([item]) {
    padding-left: var(--ui-grid-spacing);
    padding-top: var(--ui-grid-spacing);
  }
}

:host([spacing="3"]) {
  --ui-grid-spacing: calc(var(--ui-sys-unit) * 24);

  margin-left: calc(-1 * var(--ui-grid-spacing));
  margin-top: calc(-1 * var(--ui-grid-spacing));

  max-width: calc(100% + var(--ui-grid-spacing));
  max-height: calc(100% + var(--ui-grid-spacing));

  > ::slotted([item]) {
    padding-left: var(--ui-grid-spacing);
    padding-top: var(--ui-grid-spacing);
  }
}

:host([spacing="4"]) {
  --ui-grid-spacing: calc(var(--ui-sys-unit) * 32);

  margin-left: calc(-1 * var(--ui-grid-spacing));
  margin-top: calc(-1 * var(--ui-grid-spacing));

  max-width: calc(100% + var(--ui-grid-spacing));
  max-height: calc(100% + var(--ui-grid-spacing));

  > ::slotted([item]) {
    padding-left: var(--ui-grid-spacing);
    padding-top: var(--ui-grid-spacing);
  }
}

:host([item][xs]) {
  flex: 1 1 0;
  max-width: 100%;
}

:host([item][xs="1"]) {
  flex: 0 1 calc(1 / 12 * 100%);
  max-width: calc(1 / 12 * 100%);
}

:host([item][xs="2"]) {
  flex: 0 1 calc(2 / 12 * 100%);
  max-width: calc(2 / 12 * 100%);
}

:host([item][xs="3"]) {
  flex: 0 1 calc(3 / 12 * 100%);
  max-width: calc(3 / 12 * 100%);
}

:host([item][xs="4"]) {
  flex: 0 1 calc(4 / 12 * 100%);
  max-width: calc(4 / 12 * 100%);
}

:host([item][xs="5"]) {
  flex: 0 1 calc(5 / 12 * 100%);
  max-width: calc(5 / 12 * 100%);
}

:host([item][xs="6"]) {
  flex: 0 1 calc(6 / 12 * 100%);
  max-width: calc(6 / 12 * 100%);
}

:host([item][xs="7"]) {
  flex: 0 1 calc(7 / 12 * 100%);
  max-width: calc(7 / 12 * 100%);
}

:host([item][xs="8"]) {
  flex: 0 1 calc(8 / 12 * 100%);
  max-width: calc(8 / 12 * 100%);
}

:host([item][xs="9"]) {
  flex: 0 1 calc(9 / 12 * 100%);
  max-width: calc(9 / 12 * 100%);
}

:host([item][xs="10"]) {
  flex: 0 1 calc(10 / 12 * 100%);
  max-width: calc(10 / 12 * 100%);
}

:host([item][xs="11"]) {
  flex: 0 1 calc(11 / 12 * 100%);
  max-width: calc(11 / 12 * 100%);
}

:host([item][xs="12"]) {
  flex: 1 1 100%;
}

@media screen and (min-width: 600px) {
  :host([item][sm]) {
    flex: 1 1 0;
    max-width: 100%;
  }

  :host([item][sm="4"]) {
    flex: 0 1 calc(4 / 12 * 100%);
    max-width: calc(4 / 12 * 100%);
  }

  :host([item][sm="6"]) {
    flex: 0 1 50%;
    max-width: 50%;
  }
}

@media screen and (min-width: 900px) {
  :host([item][md]) {
    flex: 1 1 0;
    max-width: 100%;
  }

  :host([item][md="3"]) {
    flex: 0 1 calc(3 / 12 * 100%);
    max-width: calc(3 / 12 * 100%);
    min-width: calc(3 / 12 * 100%) ;
  }

  :host([item][md="4"]) {
    flex: 0 1 calc(4 / 12 * 100%);
    max-width: calc(4 / 12 * 100%);
    min-width: calc(4 / 12 * 100%);
  }

  :host([item][md="6"]) {
    flex: 0 1 50%;
    max-width: 50%;
  }

  :host([item][md="8"]) {
    flex: 0 1 calc(8 / 12 * 100%);
    max-width: calc(8 / 12 * 100%);
  }

  :host([item][md="9"]) {
    flex: 0 1 calc(9 / 12 * 100%);
    max-width: calc(9 / 12 * 100%);
  }

  :host([item][md="12"]) {
    flex: 0 1 100%;
    max-width: 100%;
  }
}

@media screen and (min-width: 1200px) {
  :host([item][lg]) {
    flex: 1 1 0;
    max-width: 100%;
  }

  :host([item][lg="6"]) {
    flex: 0 1 50%;
    max-width: 50%;
  }

  :host([item][lg="12"]) {
    flex: 0 1 100%;
    max-width: 100%;
  }
}`;


var $1acf786ff6f70374$export$2e2bcd8739ae039 = /* html */ `<slot></slot>`;


const $6bf427624d708ac0$export$80fd1d62079e13a6 = (0, $790lB$digitalbranchapp.defineComponent)({
    css: $e5e836ef422e1f2c$export$2e2bcd8739ae039,
    template: $1acf786ff6f70374$export$2e2bcd8739ae039
});


var $bced9f41ad2f209c$exports = {};
var $6b11093a20a08afc$exports = {};

$parcel$export($6b11093a20a08afc$exports, "uiPage", () => $6b11093a20a08afc$export$e63395db83f0a2fd);


var $295b51000eac49cd$export$2e2bcd8739ae039 = /* html */ `
<ui-grid
  @scroll="handleOnScroll"
  container
  item
  xs
  class="ui-page-body"
  *bind:class="[
    image && 'has-image'
  ]"
>
  <ui-grid
    item
    container
    xs
    *bind:direction="direction"
    class="ui-page-body-container"
    flex-wrap="nowrap"
  >
    <slot name="image"></slot>
    <slot></slot>
  </ui-grid>
</ui-grid>
`;


var $e3915328340c6f55$export$2e2bcd8739ae039 = /* css */ `
:host {
  --ui-page-body-padding-top: calc(var(--safe-area-inset-top) + calc(var(--ui-sys-unit) * 0));
  --ui-page-body-padding-bottom: calc(var(--safe-area-inset-bottom) + calc(var(--ui-sys-unit) * 32));
  --ui-page-body-padding-left: calc(var(--safe-area-inset-left) + calc(var(--ui-sys-unit) * 16));
  --ui-page-body-padding-right: calc(var(--safe-area-inset-right) + calc(var(--ui-sys-unit) * 16));
  --ui-page-body-scrollbar-color: var(--ui-sys-color-primary);

  display: block;
  position: relative;
  overflow-y: auto;
  padding-top: var(--ui-page-body-padding-top);
  padding-bottom: var(--ui-page-body-padding-bottom);
  padding-left: var(--ui-page-body-padding-left);
  padding-right: var(--ui-page-body-padding-right);
  width: 100%;
  height: 100%;
  perspective: 1px;
  perspective-origin: 0 0;
  overflow-x: hidden;
  scrollbar-color: hsl(var(--ui-page-body-scrollbar-color)) transparent;
  scrollbar-width: thin;
}

.ui-page-body {

}

ui-page-header {
  & ~ .ui-page-body {
    --ui-page-body-padding-top: calc(var(--ui-page-header-height) + var(--safe-area-inset-top));
  }
}

body.no-scroll {
  .ui-page-body {
    overflow: hidden;
  }
}

.ui-page-body-container {
  transform-style: preserve-3d;
}

@media screen and (max-width: 600px) {
  .has-image {
    --ui-page-body-padding-top: 0;
    --ui-page-body-padding-left: calc(var(--safe-area-inset-left));
    --ui-page-body-padding-right: calc(var(--safe-area-inset-right));
    --ui-page-body-padding-bottom: calc(
      var(--ui-page-header-height) + var(--safe-area-inset-bottom)
    );
  }
}

@media screen and (min-width: 1073px) {
  .ui-page-body {
    --ui-page-body-padding-bottom: calc(
      calc(var(--ui-sys-unit) * 8) + var(--safe-area-inset-bottom)
    );
  }
}

@media screen and (display-mode: standalone) {
  .ui-page-body {
    height: 100vh;
    width: 100vw;
  }
}
`;


const $fe2132382331fa90$export$3525a8e746f3f634 = (0, $790lB$digitalbranchapp.defineComponent)({
    name: 'ui-page-body',
    props: [
        {
            name: 'direction',
            type: 'string',
            default: 'column'
        }
    ],
    template: $295b51000eac49cd$export$2e2bcd8739ae039,
    css: $e3915328340c6f55$export$2e2bcd8739ae039,
    methods: {
        handleOnScroll () {}
    }
});



var $c43c141f09111c4c$export$2e2bcd8739ae039 = /* html */ `
<div
  class="ui-page-header"
  *bind:class="[
    hasTabs && 'ui-page-header--has-tabs',
  ]"
>
  <div className="ui-page-header__container"><slot></slot></div>
  <slot name="divider"></slot>
  <div class="ui-page-header__tabs"><slot name="tabs"></slot></div>
</div>
`;


var $21a9fb67628dd88c$export$2e2bcd8739ae039 = /* css */ `
:host {
  --ui-page-header-color: hsl(var(--ui-sys-color-surface));
  --ui-page-header-container-height: calc(var(--ui-sys-unit) * 64 + var(--safe-area-inset-top));
  --ui-page-header-height: calc(var(--ui-sys-unit) * 64 + var(--safe-area-inset-top));
  --ui-page-header-container-padding-top: 0;
  --ui-page-header-container-padding-right: calc(var(--ui-sys-unit) * 48 + var(--safe-area-inset-right));
  --ui-page-header-container-padding-bottom: 0;
  --ui-page-header-container-padding-left: calc(var(--ui-sys-unit) * 48 + var(--safe-area-inset-right));

  --ui-page-header-tabs-padding-top: 0;
  --ui-page-header-tabs-padding-right: calc(var(--ui-sys-unit) * 48 + var(--safe-area-inset-right));
  --ui-page-header-tabs-padding-bottom: 0;
  --ui-page-header-tabs-padding-left: calc(var(--ui-sys-unit) * 48 + var(--safe-area-inset-right));
}

.ui-page-header {
  display: flex;
  flex-direction: column;
  height: var(--ui-page-header-height);
  background-color: hsl(var(--ui-sys-color-surface));

  & ~ .ui-page-body {
    --ui-page-header-height: calc(
      var(--ui-sys-unit) * 64 + var(--safe-area-inset-top)
    );
  }

  &.ui-page-header--has-tabs {
    --ui-page-header-height: calc(
      var(--ui-sys-unit) * 64 * 2 + var(--safe-area-inset-top)
    );
    & ~ .ui-page-body {
      --ui-page-header-height: calc(
        var(--ui-sys-unit) * 64 * 2 + var(--safe-area-inset-top)
      );
    }
  }
}

.ui-page-header {
  display: flex;
  position: absolute;
  justify-content: center;
  z-index: 2;
  width: 100%;
  left: 0;
}

.ui-app-header + .ui-page,
.ui-app-header + .ui-page-transition__container .ui-page {
  .ui-page-header {
    top: var(--app-header--height);
  }
}

.ui-page-header__container {
  height: var(--ui-page-header-container-height);
  display: flex;
  align-items: center;
  flex-shrink: 0;
  width: 100%;
  padding: 0 var(--ui-page-header-container-padding-right) 0
    var(--ui-page-header-container-padding-left);
}

.ui-page-header__tabs {
  padding: 0 var(--ui-page-header-tabs-padding-right) 0
    var(--ui-page-header-tabs-padding-left);
}

@media screen and (max-width: 600px) {
  .ui-page-header {
    position: fixed;
    width: 100%;
    padding-top: var(--safe-area-inset-top);
  }

  :host {
    --ui-page-header-container-padding-right: calc(var(--ui-sys-unit) * 8 + var(--safe-area-inset-right));
    --ui-page-header-container-padding-left: calc(var(--ui-sys-unit) * 8 + var(--safe-area-inset-right));

    --ui-page-header-tabs-padding-right: calc(var(--ui-sys-unit) * 8 + var(--safe-area-inset-right));
    --ui-page-header-tabs-padding-left: calc(var(--ui-sys-unit) * 8 + var(--safe-area-inset-right));
  }
}

@media screen and (max-width: 1072px) {
  :host {
    --ui-page-header-container-padding-right: calc(var(--ui-sys-unit) * 24 + var(--safe-area-inset-right));
    --ui-page-header-container-padding-left: calc(var(--ui-sys-unit) * 24 + var(--safe-area-inset-right));

    --ui-page-header-tabs-padding-right: calc(var(--ui-sys-unit) * 24 + var(--safe-area-inset-right));
    --ui-page-header-tabs-padding-left: calc(var(--ui-sys-unit) * 24 + var(--safe-area-inset-right));
  }
}
`;


const $580c2f1c79be4501$export$f8ffaf0a67de093 = (0, $790lB$digitalbranchapp.defineComponent)({
    name: 'ui-page-header',
    css: $21a9fb67628dd88c$export$2e2bcd8739ae039,
    template: $c43c141f09111c4c$export$2e2bcd8739ae039,
    data () {
        return {
            hasTabs: false
        };
    }
});


var $d47abcea43159c27$export$2e2bcd8739ae039 = /* html */ `
<ui-grid
  container
  flex-wrap="nowrap"
  class="ui-page"
>

  <ui-grid
    item
    container
    direction="column"
    xs="12"
    sm
    class="ui-page-container"
  >
    <slot></slot>
  </ui-grid>
</ui-grid>
`;


var $768be770802e8aca$export$2e2bcd8739ae039 = /* css */ `
:host {
  --ui-page-container-padding-top: calc(var(--ui-sys-unit) * 0);
  --ui-page-container-pading-bottom: calc(var(--ui-sys-unit) * 0);

  display: block;
  height: 100%;
}

.ui-page {
  height: 100%;
}

.ui-page-container {
  height: 100%;
  position: relative;
  padding-top: var(--ui-page-container-padding-top);
  padding-bottom: var(--ui-page-container-padding-bottom);
}

@media (display-mode: standalone) {
  .ui-page,
  .ui-page-container {
    height: 100vh;
    width: 100vw;
  }
}`;



var $ed8ba72c44620a3d$export$2e2bcd8739ae039 = /* html */ `
<div
  *bind:class="[
    'ui-page-content',
    'ui-page-content--direction-' + direction
  ]"
>
  <slot></slot>
</div>
    `;


var $43d18a98b6e4d338$export$2e2bcd8739ae039 = /* css */ `
:host {
  --page-content-padding-left: var(--ui-page-content-padding-left, calc(var(--ui-sys-unit) * 48));
  --page-content-padding-right: var(--ui-page-content-padding-right, calc(var(--ui-sys-unit) * 48));
  --page-content-padding-top: var(--ui-page-content-padding-top, calc(var(--ui-sys-unit) * 16));
  --page-content-padding-bottom: var(--ui-page-content-padding-bottom, calc(var(--ui-sys-unit) * 16));
}

.ui-page-content {
  flex: 1 1;
  display: flex;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  margin: 0 auto;

  padding-left: var(--page-content-padding-left);
  padding-right: var(--page-content-padding-right);
  padding-top: var(--page-content-padding-top);
  padding-bottom: var(--page-content-padding-bottom);

  scrollbar-color: hsl(var(--ui-sys-color-primary)) transparent;
  scrollbar-width: thin;

  &.ui-page-content--direction-column {
    flex-direction: column;
  }
}

@media screen and (max-width: 1072px) {
  :host {
    --page-content-padding-left: var(--ui-page-content-padding-left, calc(var(--ui-sys-unit) * 24));
    --page-content-padding-right: var(--ui-page-content-padding-left, calc(var(--ui-sys-unit) * 24));
  }
}

@media screen and (max-width: 600px) {
  :host {
    --page-content-padding-left: var(--ui-page-content-padding-left, calc(var(--ui-sys-unit) * 16));
    --page-content-padding-right: var(--ui-page-content-padding-left, calc(var(--ui-sys-unit) * 16));
  }
}`;


const $3cace7b53c262e28$export$743b0d62436650e3 = (0, $790lB$digitalbranchapp.defineComponent)({
    name: 'ui-page-content',
    props: [
        {
            name: 'direction',
            type: 'string',
            default: 'column'
        }
    ],
    css: $43d18a98b6e4d338$export$2e2bcd8739ae039,
    template: $ed8ba72c44620a3d$export$2e2bcd8739ae039
});


const $6b11093a20a08afc$export$e63395db83f0a2fd = (0, $790lB$digitalbranchapp.defineComponent)({
    name: 'ui-page',
    css: $768be770802e8aca$export$2e2bcd8739ae039,
    template: $d47abcea43159c27$export$2e2bcd8739ae039,
    components: {
        uiPageBody: $fe2132382331fa90$export$3525a8e746f3f634,
        uiPageHeader: $580c2f1c79be4501$export$f8ffaf0a67de093,
        uiPageContent: $3cace7b53c262e28$export$743b0d62436650e3
    }
});


$parcel$exportWildcard($bced9f41ad2f209c$exports, $6b11093a20a08afc$exports);


var $b415a23ffc1df348$exports = {};

$parcel$export($b415a23ffc1df348$exports, "uiHeading", () => $b415a23ffc1df348$export$705964f417755732);

var $57d9a1dc4158dc2d$export$2e2bcd8739ae039 = /* html */ `
<h1 *if="type === 'h1'"><slot></slot></h1>
<h2 *if="type === 'h2'"><slot></slot></h2>
<h3 *if="type === 'h3'"><slot></slot></h3>
<h4 *if="type === 'h4'"><slot></slot></h4>
<h5 *if="type === 'h5'"><slot></slot></h5>
<h6 *if="type === 'h6'"><slot></slot></h6>
`;


var $7377e4488253695c$export$2e2bcd8739ae039 = /* css */ `
:host {
  --ui-heading-font-size: var(--ui-sys-typescale-display-large-font-size);
  --ui-heading-line-height: var(--ui-sys-typescale-display-large-line-height);
  --ui-heading-font-weight: var(--ui-sys-typescale-display-large-font-weight);
}

h1 {
  color: hsl(var(--ui-sys-color-on-surface));
  font-size: var(--ui-heading-font-size);
  line-height: var(--ui-heading-line-height);
  font-weight: var(--ui-heading-font-weight);
  margin-top: 0;
  margin-bottom: calc(var(--ui-sys-unit) * 28);
}
h2 {
  color: hsl(var(--ui-sys-color-on-surface));
  font-size: var(--ui-sys-typescale-display-medium-font-size);
  line-height: var(--ui-sys-typescale-display-medium-line-height);
  font-weight: var(--ui-sys-typescale-display-medium-font-weight);
  margin-top: 0;
  margin-bottom: calc(var(--ui-sys-unit) * 24);
}

h3 {
  color: hsl(var(--ui-sys-color-on-surface));
  font-size: var(--ui-sys-typescale-display-small-font-size);
  line-height: var(--ui-sys-typescale-display-small-line-height);
  font-weight: var(--ui-sys-typescale-display-small-font-weight);
  margin-top: 0;
  margin-bottom: calc(var(--ui-sys-unit) * 20);
}

h4 {
  color: hsl(var(--ui-sys-color-on-surface));
  font-size: var(--ui-sys-typescale-headline-large-font-size);
  line-height: var(--ui-sys-typescale-headline-large-line-height);
  font-weight: var(--ui-sys-typescale-headline-large-font-weight);
  margin-top: 0;
  margin-bottom: calc(var(--ui-sys-unit) * 16);
}

h5 {
  color: hsl(var(--ui-sys-color-on-surface));
  font-size: var(--ui-sys-typescale-headline-medium-font-size);
  line-height: var(--ui-sys-typescale-headline-medium-line-height);
  font-weight: var(--ui-sys-typescale-headline-medium-font-weight);
  margin-top: 0;
  margin-bottom: calc(var(--ui-sys-unit) * 16);
}

h6 {
  color: hsl(var(--ui-sys-color-on-surface));
  font-size: var(--ui-sys-typescale-headline-small-font-size);
  line-height: var(--ui-sys-typescale-headline-small-line-height);
  font-weight: var(--ui-sys-typescale-headline-small-font-weight);
  margin-top: 0;
  margin-bottom: calc(var(--ui-sys-unit) * 16);
}
`;


const $b415a23ffc1df348$export$705964f417755732 = (0, $790lB$digitalbranchapp.defineComponent)({
    name: 'ui-heading',
    props: [
        {
            name: 'type',
            type: 'string',
            required: true
        }
    ],
    template: $57d9a1dc4158dc2d$export$2e2bcd8739ae039,
    css: $7377e4488253695c$export$2e2bcd8739ae039
});


var $b98eb940bdba2931$exports = {};

$parcel$export($b98eb940bdba2931$exports, "uiParagraph", () => $b98eb940bdba2931$export$b8e78834af1b9dfe);

var $1023cb24fa28da36$export$2e2bcd8739ae039 = /* html */ `
<p><slot></slot></p>
`;


var $473ff13dbcf44325$export$2e2bcd8739ae039 = /* css */ `
:host {
  --ui-paragraph-font-size: var(--ui-sys-typescale-body-large-font-size);
  --ui-paragraph-line-height: var(--ui-sys-typescale-body-large-line-height);
  --ui-paragraph-font-weight: var(--ui-sys-typescale-body-large-font-weight);
}
p {
  font-size: var(--ui-paragraph-font-size);
  line-height: var(--ui-paragraph-line-height);
  /* letter-spacing: var(--ui-sys-typescale-body-large-letter-spacing); */
  font-weight: var(--ui-paragraph-font-weight);
  margin-top: 0;
}
`;


const $b98eb940bdba2931$export$b8e78834af1b9dfe = (0, $790lB$digitalbranchapp.defineComponent)({
    name: 'ui-paragraph',
    template: $1023cb24fa28da36$export$2e2bcd8739ae039,
    css: $473ff13dbcf44325$export$2e2bcd8739ae039
});


var $25d4ea400f79c3d1$exports = {};

$parcel$export($25d4ea400f79c3d1$exports, "uiTemplate", () => $25d4ea400f79c3d1$export$63c2706854dfa68c);

var $1ba39b0db1a58187$export$2e2bcd8739ae039 = /* html */ `<slot></slot>`;


const $25d4ea400f79c3d1$export$63c2706854dfa68c = (0, $790lB$digitalbranchapp.defineComponent)({
    name: 'ui-template',
    template: $1ba39b0db1a58187$export$2e2bcd8739ae039
});


var $64ca9069bfc7a54e$exports = {};
var $c699d33479f9790d$exports = {};

$parcel$export($c699d33479f9790d$exports, "uiCard", () => $c699d33479f9790d$export$976297bdedb44589);

var $6a8eb1aa7e2832f2$export$2e2bcd8739ae039 = /* html */ `
<div
  class="ui-card ui-sys-elevation-layer"
  *bind:class="[
    'ui-card--variant-' + variant,
    'ui-sys-elevation-layer'
  ]"
>
  <div className="ui-card__container">
    <slot></slot>
  </div>
</div>`;


var $1bbba086b302a80c$export$2e2bcd8739ae039 = /* css */ `
:host {
  --card-container-shape: var(--ui-card-container-shape, var(--ui-sys-shape-corner-medium));
}

.ui-card {
  background-color: hsl(var(--ui-card-container-color));
  border-radius: var(--card-container-shape);
  border: var(--ui-card-outline-width, 0) solid
    hsl(var(--ui-card-outline-color, 0, 0, 0, 0));
  position: relative;
  width: inherit;

  &.ui-card--variant-elevated {
    --ui-card-elevation-shadow: var(--ui-sys-elevation-level1-shadow);
    --ui-card-container-color: var(--ui-sys-color-surface-container-low);

    &.ui-card--is-clickable {
      --ui-card-pressed-state-layer-color: var(--ui-sys-color-on-surface);

      &:hover {
        --ui-card-elevation-shadow: var(--ui-sys-elevation-level2-shadow);

        .ui-sys-state-layer:before {
          --ui-card-hover-state-layer-color: var(--ui-sys-color-on-surface);
          --ui-card-hovers-state-layer-opacity: var(
            --ui-sys-state-hover-state-layer-opacity
          );
        }
      }

      &.ui-card--is-pressed {
        --ui-card-elevation-shadow: var(--ui-sys-elevation-level1-shadow);
      }
    }
  }

  &.ui-card--variant-filled {
    --ui-card-container-color: var(--ui-sys-color-surface-container-highest);
    --ui-card-title-color: var(--ui-sys-color-on-surface);
  }

  &.ui-card--variant-outlined {
    --ui-card-container-color: var(--ui-sys-color-surface);
    --ui-card-outline-width: calc(var(--ui-sys-unit) * 1);
    --ui-card-outline-color: var(--ui-sys-color-outline-variant);
  }

  &.ui-sys-elevation-layer:after {
    --ui-sys-elevation-layer-shadow: var(--ui-card-elevation-shadow);
  }

  .ui-sys-state-layer:before {
    --ui-sys-state-layer-color: var(--ui-card-hover-state-layer-color);
    --ui-sys-state-layer-opacity: var(--ui-card-hover-state-layer-opacity);
  }

  &.ui-card--is-clickable {
    cursor: pointer;
  }

  .ui-ripple {
    --ui-ripple-color: var(--ui-card-pressed-state-layer-color);
  }

  .ui-card__container {
    overflow: hidden;
    border-radius: var(--card-container-shape);
    width: 100%;
    height: 100%;
  }
}`;


const $c699d33479f9790d$export$976297bdedb44589 = (0, $790lB$digitalbranchapp.defineComponent)({
    name: 'ui-card',
    props: [
        {
            name: 'variant',
            type: 'string',
            default: 'filled'
        }
    ],
    template: $6a8eb1aa7e2832f2$export$2e2bcd8739ae039,
    css: $1bbba086b302a80c$export$2e2bcd8739ae039
});


var $8341c259e1965f82$exports = {};

$parcel$export($8341c259e1965f82$exports, "uiCardContent", () => $8341c259e1965f82$export$b3b79ee429a76074);

var $f59fad9ed6f6828c$export$2e2bcd8739ae039 = /* html */ `
<div class="ui-card-content">
  <slot></slot>
</div>`;


var $3fa6513dc778503a$export$2e2bcd8739ae039 = /* css */ `
:host {
  --ui-card-content-padding-left: calc(var(--ui-sys-unit) * 16);
  --ui-card-content-padding-right: calc(var(--ui-sys-unit) * 16);
  --ui-card-content-padding-top: calc(var(--ui-sys-unit) * 16);
  --ui-card-content-padding-bottom: calc(var(--ui-sys-unit) * 16);
}

.ui-card-content {
  padding-left: var(--ui-card-content-padding-left);
  padding-right: var(--ui-card-content-padding-right);
  padding-top: var(--ui-card-content-padding-top);
  padding-bottom: var(--ui-card-content-padding-bottom);
}`;


const $8341c259e1965f82$export$b3b79ee429a76074 = (0, $790lB$digitalbranchapp.defineComponent)({
    name: 'ui-card-content',
    template: $f59fad9ed6f6828c$export$2e2bcd8739ae039,
    css: $3fa6513dc778503a$export$2e2bcd8739ae039
});


$parcel$exportWildcard($64ca9069bfc7a54e$exports, $c699d33479f9790d$exports);
$parcel$exportWildcard($64ca9069bfc7a54e$exports, $8341c259e1965f82$exports);


$parcel$exportWildcard($131d50229c8def6f$exports, $eb7c8ab7a231f03b$exports);
$parcel$exportWildcard($131d50229c8def6f$exports, $9703e2f3f4452c31$exports);
$parcel$exportWildcard($131d50229c8def6f$exports, $f426a6f7e59a728c$exports);
$parcel$exportWildcard($131d50229c8def6f$exports, $54616f3c284718ab$exports);
$parcel$exportWildcard($131d50229c8def6f$exports, $c4102ef8d2d773ae$exports);
$parcel$exportWildcard($131d50229c8def6f$exports, $2901ec8635684cc3$exports);
$parcel$exportWildcard($131d50229c8def6f$exports, $b7a7a0ec9978f890$exports);
$parcel$exportWildcard($131d50229c8def6f$exports, $e0bf9c330ac08625$exports);
$parcel$exportWildcard($131d50229c8def6f$exports, $2424a852aecdbf67$exports);
$parcel$exportWildcard($131d50229c8def6f$exports, $b86cefd5916fc45e$exports);
$parcel$exportWildcard($131d50229c8def6f$exports, $6bf427624d708ac0$exports);
$parcel$exportWildcard($131d50229c8def6f$exports, $bced9f41ad2f209c$exports);
$parcel$exportWildcard($131d50229c8def6f$exports, $b415a23ffc1df348$exports);
$parcel$exportWildcard($131d50229c8def6f$exports, $b98eb940bdba2931$exports);
$parcel$exportWildcard($131d50229c8def6f$exports, $25d4ea400f79c3d1$exports);
$parcel$exportWildcard($131d50229c8def6f$exports, $64ca9069bfc7a54e$exports);


$parcel$exportWildcard(module.exports, $131d50229c8def6f$exports);


//# sourceMappingURL=index.js.map
